<template>
    <div class="container-fluid">
        <h1 class="text-left">{{ title }}</h1>
        <br />
        <b-form
            ref="feedbackform"
            class="pb-5"
            v-if="!loading"
            name="feedbackform"
            v-on:submit.prevent="$_onSubmit"
            novalidate
        >
            <div class="col-xs-8 col-md-5">
                <!-- Name -->
                <div>
                    <x-input
                        :id="`txtFeedbackName`"
                        :name="`txtFeedbackName`"
                        :text="$t('columnNameName')"
                        maxlength="40"
                        :state="!nameError"
                        v-model="feedback.name"
                        @input="$_checkLayerName"
                        :invalidMessage="nameInvalidMessage"
                        :plaintext="$_feedbackNamePlainText"
                        :required="!editMode"
                        autofocus
                    >
                    </x-input>
                </div>
                <!-- Alias -->
                <div>
                    <x-input
                        :id="`txtFeedbackAlias`"
                        :name="`txtFeedbackAlias`"
                        :text="'Alias'"
                        maxlength="50"
                        :state="!aliasError"
                        v-model="feedback.alias"
                        @input="$_checkLayerAlias"
                        :invalidMessage="aliasInvalidMessage"
                        required
                    >
                    </x-input>
                </div>
                <!-- Keywords -->
                <div>
                    <x-input
                        :id="`txtFeedbackKeywords`"
                        :name="`txtFeedbackKeywords`"
                        :text="'Trefwoorden'"
                        maxlength="200"
                        v-model="feedback.keywords"
                        @input="$_feedbacklayerHasError"
                        required
                    >
                    </x-input>
                </div>
                <!-- ContentTypeId -->
                <div>
                    <b-form-group>
                        <b-form-radio-group
                            id="radioContentType"
                            name="radioContentType"
                            :disabled="this.editMode"
                            v-model="feedback.contentTypeId"
                            :options="contentTypeOptions"
                            @change="$_onChangeContentType"
                        >
                        </b-form-radio-group>
                    </b-form-group>
                </div>
                <!-- Personal -->
                <!-- Use in webtheme -->
                <div
                    v-show="userInfo.hasWebLicense"
                    class="form-group col-xs-8 no-margin-bottom"
                >
                    <h4>{{ $t('menuItemSettings') }}</h4>
                    <x-checkbox
                        :name="'privateData'"
                        v-if="
                            feedback.contentTypeId ===
                            contentTypeConst.MEASUREMENT
                        "
                        :disabled="$_isUsedInWebAndMeasurement"
                        v-model="feedback.personal"
                        :text="$t('personal')"
                    >
                    </x-checkbox>
                    <x-checkbox
                        :name="'chkUseInWebTheme'"
                        :disabled="$_useInWebThemeEnabled()"
                        v-model="feedback.useInWebTheme"
                        @input="$_onChangeUseInWebTheme"
                        :text="$t('useInWebthemeCard')"
                    >
                    </x-checkbox>
                    <x-checkbox
                        v-if="
                            !feedback.useInWebTheme &&
                            feedback.contentTypeId === contentTypeConst.FEEDBACK
                        "
                        :name="'chkSendStatusUpdates'"
                        v-model="feedback.sendStatusUpdates"
                        @input="$_onChangeSendStatusUpdates"
                        text="Status updates versturen"
                        :disabled="
                            this.editMode && this.originalSendStatusUpdates
                        "
                    >
                    </x-checkbox>
                </div>
                <!-- Export -->
                <x-checkbox
                    :id="'exportFeedback'"
                    :name="'exportFeedback'"
                    v-if="!$_isUsedInWebAndMeasurement"
                    v-model="feedback.exportable"
                    @input="$_onChangeExportFeedback"
                    :text="$t('labelExportable')"
                >
                </x-checkbox>
                <!-- Print -->
                <x-checkbox
                    :id="'printFeedback'"
                    :name="'printFeedback'"
                    v-if="!$_isUsedInWebAndMeasurement"
                    v-model="feedback.print"
                    :text="$t('labelPrint')"
                >
                </x-checkbox>
                <x-checkbox
                    :name="'chkSavePhotoWithUrl'"
                    :disabled="!hasPhotoFields"
                    v-model="feedback.savePhotoWithUrl"
                    :text="$t('labelSavePhotoWithUrl')"
                >
                </x-checkbox>
                <x-checkbox
                    v-if="feedback.contentTypeId === contentTypeConst.FEEDBACK"
                    :name="'chkChangeLogEnabled'"
                    v-model="feedback.changeLogEnabled"
                    :text="$t('labelChangeLogEnabled')"
                >
                </x-checkbox>
            </div>
            <br />
            <div class="col-xs-12 col-md-9">
                <!-- GeometryType -->
                <!-- P for point, L for line, V for vlak (= polygon) -->
                <b-form-group :label="$t('geomType')">
                    <b-form-checkbox-group
                        v-model="feedback.geometryTypeArray"
                        @input="$_setGeometryType($event)"
                        :required="feedback.geometryType.length === 0"
                    >
                        <b-form-checkbox :name="'chkGeoTypePoint'" value="P">
                            {{ $t('geomPoint') }}
                        </b-form-checkbox>
                        <b-form-checkbox :name="'chkGeoTypeLine'" value="L">
                            {{ $t('geomLine') }}
                        </b-form-checkbox>
                        <b-form-checkbox :name="'chkGeoTypePolygon'" value="V">
                            {{ $t('geomPolygon') }}
                        </b-form-checkbox>
                    </b-form-checkbox-group>
                    <span
                        v-show="$_hasMissingGeometryType"
                        class="text-danger"
                        readonly
                    >
                        {{ $t('errorMissingGeometryType') }}
                    </span>
                    <!-- Buttontext -->
                    <div
                        v-if="feedback.useInWebTheme && hasLineOrPolygonType"
                        class="mt-2"
                    >
                        <x-input
                            :id="`txtFeedbackButtonText`"
                            :name="`txtFeedbackButtonText`"
                            :text="$t('labelFeedbackButtonText')"
                            maxlength="50"
                            v-model="feedback.buttonText"
                        >
                        </x-input>
                    </div>
                </b-form-group>
                <!-- Opmaak -->
                <div class="col-xs-12 col-md-12">
                    <b-card no-body class="mb-1">
                        <b-card-header
                            v-b-toggle="`accfeedback${feedback.id}`"
                            header-tag="header"
                            class="p-1"
                            role="tab"
                            data-toggle="collapse"
                        >
                            <span>{{ $t('labelLayout') }}</span>
                            <em class="float-right fa"></em>
                        </b-card-header>
                        <b-collapse
                            :id="`accfeedback${feedback.id}`"
                            accordion="feedbackaccordion"
                            role="tabpanel"
                            visible
                        >
                            <b-card-body>
                                <b-tabs content-class="mt-3">
                                    <!--Invoervelden-->
                                    <b-tab
                                        :title="$t('labelInputFieldsStyle')"
                                        active
                                    >
                                        <v-draggable
                                            :list="feedback.feedbackFields"
                                            handle=".fa-arrows-alt"
                                        >
                                            <div
                                                role="tablist"
                                                v-for="(
                                                    feedbackField, index
                                                ) in orderedFeedbackFields"
                                                :key="index"
                                            >
                                                <b-card no-body class="mb-1">
                                                    <b-card-header
                                                        v-b-toggle="
                                                            `accfeedbackField${feedbackField.id}`
                                                        "
                                                        header-tag="header"
                                                        class="p-1"
                                                        role="tab"
                                                        data-toggle="collapse"
                                                    >
                                                        <em
                                                            class="fa fa-arrows-alt"
                                                        ></em>
                                                        <span>
                                                            {{
                                                                feedbackField.alias
                                                            }}
                                                        </span>
                                                        <span
                                                            class="float-right"
                                                        >
                                                            <!-- Delete icon in header -->
                                                            <a
                                                                :id="`btnDelete${feedbackField.id}`"
                                                                :name="`btnDelete${feedbackField.id}`"
                                                                v-if="
                                                                    $_showDeleteButton(
                                                                        feedbackField
                                                                    )
                                                                "
                                                                :title="
                                                                    $t(
                                                                        'feedbackRemoveInputfield'
                                                                    )
                                                                "
                                                                class="pr-4"
                                                                @click.stop.prevent="
                                                                    $_removeItem(
                                                                        index,
                                                                        itemTypes.feedbackField,
                                                                        feedback.feedbackFields,
                                                                        feedbackField
                                                                    )
                                                                "
                                                            >
                                                                <em
                                                                    class="fas fa-trash-alt fa-sm"
                                                                ></em>
                                                            </a>
                                                            <!-- Expand/collapse icon -->
                                                            <em
                                                                class="fa iconCollapseExpand"
                                                            ></em>
                                                        </span>
                                                    </b-card-header>
                                                    <b-collapse
                                                        :id="`accfeedbackField${feedbackField.id}`"
                                                        accordion="feedbackfieldaccordion"
                                                        role="tabpanel"
                                                        :visible="
                                                            feedbackField.newi
                                                        "
                                                        @show="
                                                            $_onFieldShow(
                                                                feedbackField
                                                            )
                                                        "
                                                    >
                                                        <div
                                                            class="row-divider"
                                                        ></div>
                                                        <!-- Name -->
                                                        <div
                                                            class="keep-inline"
                                                        >
                                                            <div
                                                                class="float-right col-md-12"
                                                            >
                                                                <x-input
                                                                    :id="`${feedbackField.name}_name`"
                                                                    :name="`${feedbackField.name}_name`"
                                                                    :text="
                                                                        $t(
                                                                            'columnNameName'
                                                                        )
                                                                    "
                                                                    lableAlignment="4"
                                                                    maxlength="50"
                                                                    v-model="
                                                                        feedbackField.name
                                                                    "
                                                                    @input="
                                                                        $_fbFieldNameAllowed(
                                                                            feedbackField
                                                                        )
                                                                    "
                                                                    :state="
                                                                        !$_isStringNotEmpty(
                                                                            feedbackField.invalidFieldNameErrorMessage
                                                                        )
                                                                    "
                                                                    :invalidMessage="
                                                                        feedbackField.invalidFieldNameErrorMessage
                                                                    "
                                                                    :plaintext="
                                                                        $_isEditModeOrGenericType(
                                                                            feedbackField
                                                                        )
                                                                    "
                                                                    required
                                                                >
                                                                </x-input>
                                                            </div>
                                                        </div>
                                                        <!-- Alias -->
                                                        <div
                                                            class="keep-inline"
                                                        >
                                                            <div
                                                                class="float-right col-md-12"
                                                            >
                                                                <x-input
                                                                    :id="`${feedbackField.name}_alias`"
                                                                    :name="`${feedbackField.name}_alias`"
                                                                    maxlength="50"
                                                                    :text="
                                                                        $t(
                                                                            'labelAlias'
                                                                        )
                                                                    "
                                                                    lableAlignment="4"
                                                                    v-model="
                                                                        feedbackField.alias
                                                                    "
                                                                    @input="
                                                                        $_validateFieldAlias(
                                                                            feedbackField
                                                                        )
                                                                    "
                                                                    :state="
                                                                        !$_isStringNotEmpty(
                                                                            feedbackField.invalidFieldAliasErrorMessage
                                                                        )
                                                                    "
                                                                    :invalidMessage="
                                                                        feedbackField.invalidFieldAliasErrorMessage
                                                                    "
                                                                    required
                                                                >
                                                                </x-input>
                                                            </div>
                                                        </div>
                                                        <!-- Type -->
                                                        <div
                                                            class="keep-inline"
                                                        >
                                                            <div
                                                                class="float-right col-md-12"
                                                            >
                                                                <x-select
                                                                    :id="`${feedbackField.name}_type`"
                                                                    :name="`${feedbackField.name}_type`"
                                                                    :text="
                                                                        $t(
                                                                            'columnTypeTitle'
                                                                        )
                                                                    "
                                                                    lableAlignment="4"
                                                                    v-model="
                                                                        feedbackField.type
                                                                    "
                                                                    @selected="
                                                                        $_setDefaultFieldTypeValues(
                                                                            $event,
                                                                            feedbackField
                                                                        )
                                                                    "
                                                                    :options="
                                                                        $_typeOptions(
                                                                            feedbackField
                                                                        )
                                                                    "
                                                                    :disabled="
                                                                        $_isEditModeOrGenericType(
                                                                            feedbackField
                                                                        )
                                                                    "
                                                                    :extendedClass="{
                                                                        plaintext:
                                                                            $_isEditModeOrGenericType(
                                                                                feedbackField
                                                                            )
                                                                    }"
                                                                    :required="
                                                                        true
                                                                    "
                                                                    :textDefaultOption="
                                                                        $t(
                                                                            'selectBoxMakeChoice'
                                                                        )
                                                                    "
                                                                    :state="
                                                                        feedbackField.newi ===
                                                                        true
                                                                            ? !$_isStringNotEmpty(
                                                                                  feedbackField.typeErrorMessage
                                                                              )
                                                                            : null
                                                                    "
                                                                    :invalidMessage="
                                                                        feedbackField.typeErrorMessage
                                                                    "
                                                                    :simpleMode="
                                                                        true
                                                                    "
                                                                >
                                                                </x-select>
                                                            </div>
                                                        </div>
                                                        <!-- Placeholder -->
                                                        <div
                                                            v-if="
                                                                $_showPlaceholderInput(
                                                                    feedbackField
                                                                )
                                                            "
                                                            class="keep-inline"
                                                        >
                                                            <div
                                                                class="float-right col-md-12"
                                                            >
                                                                <x-input
                                                                    :id="`${feedbackField.name}_placeholder`"
                                                                    :name="`${feedbackField.name}_placeholder`"
                                                                    :text="'Toelichting in invoerveld:'"
                                                                    lableAlignment="4"
                                                                    v-model="
                                                                        feedbackField.placeholder
                                                                    "
                                                                >
                                                                </x-input>
                                                            </div>
                                                        </div>
                                                        <!-- Category -->
                                                        <div
                                                            v-if="
                                                                categoriesCalculated &&
                                                                feedbackField.type ===
                                                                    fieldTypeConst.CATEGORY
                                                            "
                                                            class="keep-inline"
                                                        >
                                                            <label
                                                                class="text-left col-md-4"
                                                                >Categorieën</label
                                                            >
                                                            <div
                                                                class="float-right col-md-8"
                                                            >
                                                                <div
                                                                    v-for="categorie in $_ordedCategories(
                                                                        feedbackField.categories
                                                                    )"
                                                                    v-bind:key="
                                                                        categorie.name
                                                                    "
                                                                >
                                                                    <x-checkbox
                                                                        :id="`category_${categorie.name}`"
                                                                        :name="`category_${categorie.name}`"
                                                                        v-model="
                                                                            categorie.selected
                                                                        "
                                                                        @input="
                                                                            $_feedbackFieldCategoryOptions(
                                                                                feedbackField
                                                                            )
                                                                        "
                                                                        :text="
                                                                            categorie.name
                                                                        "
                                                                        :state="
                                                                            catetoryState
                                                                        "
                                                                    >
                                                                    </x-checkbox>
                                                                </div>
                                                                <b-form-invalid-feedback
                                                                    v-if="
                                                                        catetoryState ===
                                                                        false
                                                                    "
                                                                    :state="
                                                                        catetoryState
                                                                    "
                                                                >
                                                                    {{
                                                                        invalidCategoryMessage
                                                                    }}
                                                                </b-form-invalid-feedback>
                                                            </div>
                                                        </div>
                                                        <!-- Required -->
                                                        <div
                                                            v-if="
                                                                feedbackField.type !==
                                                                    fieldTypeConst.GENERIC &&
                                                                feedbackField.type !==
                                                                    fieldTypeConst.EXPRESSION
                                                            "
                                                            class="keep-inline"
                                                        >
                                                            <label
                                                                class="text-left col-md-4"
                                                                >Verplicht</label
                                                            >
                                                            <div
                                                                class="float-right col-md-8"
                                                            >
                                                                <x-checkbox
                                                                    :id="`${feedbackField.name}_required`"
                                                                    :name="`${feedbackField.name}_required`"
                                                                    v-model="
                                                                        feedbackField.required
                                                                    "
                                                                    @change="
                                                                        $_feedbacklayerHasError()
                                                                    "
                                                                >
                                                                </x-checkbox>
                                                            </div>
                                                        </div>
                                                        <!-- Visible -->
                                                        <div
                                                            v-if="
                                                                !(
                                                                    feedbackField.type ===
                                                                    fieldTypeConst.GENERIC
                                                                )
                                                            "
                                                            class="keep-inline"
                                                        >
                                                            <label
                                                                class="text-left col-md-4"
                                                            >
                                                                Zichtbaar bij
                                                                aanmaken
                                                            </label>
                                                            <div
                                                                class="float-right col-md-8"
                                                            >
                                                                <x-checkbox
                                                                    :name="`${feedbackField.name}_visible`"
                                                                    v-model="
                                                                        feedbackField.visible
                                                                    "
                                                                    :disabled="
                                                                        feedbackField.type ===
                                                                        fieldTypeConst.STATE
                                                                    "
                                                                >
                                                                </x-checkbox>
                                                            </div>
                                                        </div>
                                                        <!-- Table display -->
                                                        <div
                                                            v-if="
                                                                feedbackField.type !==
                                                                fieldTypeConst.VIDEO
                                                            "
                                                            class="keep-inline"
                                                        >
                                                            <label
                                                                class="text-left col-md-4"
                                                            >
                                                                Tabel weergave
                                                            </label>
                                                            <div
                                                                class="float-right col-md-8"
                                                            >
                                                                <x-checkbox
                                                                    :name="`${feedbackField.name}_tableView`"
                                                                    v-model="
                                                                        feedbackField.tableView
                                                                    "
                                                                >
                                                                </x-checkbox>
                                                            </div>
                                                        </div>
                                                        <!-- Detail display -->
                                                        <div
                                                            class="keep-inline"
                                                        >
                                                            <label
                                                                class="text-left col-md-4"
                                                            >
                                                                Detail weergave
                                                            </label>
                                                            <div
                                                                class="float-right col-md-8"
                                                            >
                                                                <x-checkbox
                                                                    :name="`${feedbackField.name}_detailView`"
                                                                    v-model="
                                                                        feedbackField.detailView
                                                                    "
                                                                >
                                                                </x-checkbox>
                                                            </div>
                                                        </div>
                                                        <!-- Popup display -->
                                                        <div
                                                            class="keep-inline"
                                                        >
                                                            <label
                                                                class="text-left col-md-4"
                                                            >
                                                                Eén venster
                                                                weergave
                                                            </label>
                                                            <div
                                                                class="float-right col-md-8"
                                                            >
                                                                <x-checkbox
                                                                    :name="`${feedbackField.name}_popUp`"
                                                                    v-model="
                                                                        feedbackField.popUp
                                                                    "
                                                                >
                                                                </x-checkbox>
                                                            </div>
                                                        </div>
                                                        <!-- Search attribute -->
                                                        <div
                                                            v-if="
                                                                feedbackField.type ===
                                                                    fieldTypeConst.ALPHANUMERIC ||
                                                                feedbackField.type ===
                                                                    fieldTypeConst.NUMERIC ||
                                                                feedbackField.type ===
                                                                    fieldTypeConst.NUMERICWITHDECIMALS ||
                                                                feedbackField.type ===
                                                                    fieldTypeConst.GENERIC ||
                                                                feedbackField.type ===
                                                                    fieldTypeConst.CATEGORY ||
                                                                feedbackField.type ===
                                                                    fieldTypeConst.STATE
                                                            "
                                                            class="keep-inline"
                                                        >
                                                            <label
                                                                class="text-left col-md-4"
                                                                >Zoekeigenschap</label
                                                            >
                                                            <div
                                                                class="float-right col-md-8"
                                                            >
                                                                <b-form-checkbox
                                                                    :id="`${feedbackField.name}_searchType`"
                                                                    :name="`${feedbackField.name}_searchType`"
                                                                    v-model="
                                                                        feedbackField.searchType
                                                                    "
                                                                    @change="
                                                                        $_harvestNotification(
                                                                            $event
                                                                        )
                                                                    "
                                                                    :disabled="
                                                                        feedbackField.name ===
                                                                        'aansluitnummer'
                                                                    "
                                                                >
                                                                </b-form-checkbox>
                                                            </div>
                                                        </div>
                                                        <!-- Export -->
                                                        <div
                                                            v-if="
                                                                !$_isUsedInWebAndMeasurement
                                                            "
                                                            class="keep-inline"
                                                        >
                                                            <label
                                                                v-show="
                                                                    feedback.exportable
                                                                "
                                                                class="text-left col-md-4"
                                                            >
                                                                {{
                                                                    $t(
                                                                        'labelExportable'
                                                                    )
                                                                }}
                                                            </label>
                                                            <div
                                                                v-show="
                                                                    feedback.exportable
                                                                "
                                                                class="float-right col-md-8"
                                                            >
                                                                <x-checkbox
                                                                    :name="`${feedbackField.name}_ExportFeedbackField`"
                                                                    :disabled="
                                                                        feedback.exportable ===
                                                                        false
                                                                    "
                                                                    v-model="
                                                                        feedbackField.exportable
                                                                    "
                                                                >
                                                                </x-checkbox>
                                                            </div>
                                                        </div>
                                                        <!-- Print -->
                                                        <div
                                                            v-if="
                                                                !$_isUsedInWebAndMeasurement
                                                            "
                                                            class="keep-inline"
                                                        >
                                                            <label
                                                                v-show="
                                                                    feedback.print
                                                                "
                                                                class="text-left col-md-4"
                                                            >
                                                                {{
                                                                    $t(
                                                                        'labelPrint'
                                                                    )
                                                                }}
                                                            </label>
                                                            <div
                                                                v-show="
                                                                    feedback.print
                                                                "
                                                                class="float-right col-md-8"
                                                            >
                                                                <x-checkbox
                                                                    :name="`${feedbackField.name}_PrintFeedbackField`"
                                                                    :disabled="
                                                                        feedback.print ===
                                                                        false
                                                                    "
                                                                    v-model="
                                                                        feedbackField.print
                                                                    "
                                                                >
                                                                </x-checkbox>
                                                            </div>
                                                        </div>
                                                        <!-- Contact details -->
                                                        <div
                                                            v-if="
                                                                $_displayContactInformationField(
                                                                    feedbackField
                                                                )
                                                            "
                                                            class="keep-inline"
                                                        >
                                                            <label
                                                                class="text-left col-md-4"
                                                            >
                                                                {{
                                                                    $t(
                                                                        'labelContactInformation'
                                                                    )
                                                                }}
                                                            </label>
                                                            <div
                                                                class="float-right col-md-8"
                                                            >
                                                                <x-checkbox
                                                                    :name="`${feedbackField.name}_personalData`"
                                                                    v-model="
                                                                        feedbackField.personalData
                                                                    "
                                                                    :disabled="
                                                                        feedbackField.type ===
                                                                        fieldTypeConst.EMAIL
                                                                    "
                                                                >
                                                                </x-checkbox>
                                                            </div>
                                                        </div>
                                                        <div
                                                            v-if="
                                                                feedbackField.type ===
                                                                    fieldTypeConst.ALPHANUMERIC ||
                                                                feedbackField.type ===
                                                                    fieldTypeConst.STATE
                                                            "
                                                            class="row-divider"
                                                        ></div>
                                                        <!-- Domeinwaarden -->
                                                        <div
                                                            v-if="
                                                                feedbackField.type ===
                                                                    fieldTypeConst.ALPHANUMERIC ||
                                                                feedbackField.type ===
                                                                    fieldTypeConst.STATE
                                                            "
                                                            class="keep-inline"
                                                        >
                                                            <label
                                                                class="text-left col-md-4"
                                                            >
                                                                {{
                                                                    $t(
                                                                        'labelDomain'
                                                                    )
                                                                }}
                                                            </label>
                                                            <div
                                                                class="float-right col-md-8"
                                                            >
                                                                <b-form-select
                                                                    :id="`${feedbackField.name}_domain`"
                                                                    :name="`${feedbackField.name}_domain`"
                                                                    v-model="
                                                                        feedbackField.domainId
                                                                    "
                                                                    :options="
                                                                        domainOptions
                                                                    "
                                                                    :required="
                                                                        feedbackField.type ===
                                                                        fieldTypeConst.STATE
                                                                    "
                                                                    @change="
                                                                        $_domainSelected(
                                                                            $event,
                                                                            feedbackField
                                                                        )
                                                                    "
                                                                >
                                                                    <template
                                                                        v-slot:first
                                                                    >
                                                                        <option
                                                                            :value="
                                                                                null
                                                                            "
                                                                        >
                                                                            {{
                                                                                $_getDefaultOptionDomain(
                                                                                    feedbackField
                                                                                )
                                                                            }}
                                                                        </option>
                                                                    </template>
                                                                </b-form-select>
                                                                <b-link
                                                                    :id="`${feedbackField.name}addDomein`"
                                                                    :name="`${feedbackField.name}addDomein`"
                                                                    @click="
                                                                        $_openDomainModal(
                                                                            feedbackField
                                                                        )
                                                                    "
                                                                >
                                                                    <em
                                                                        class="fa fa-plus"
                                                                    ></em>
                                                                    {{
                                                                        $t(
                                                                            'domainAddButton'
                                                                        )
                                                                    }}
                                                                </b-link>
                                                            </div>
                                                        </div>
                                                        <div
                                                            v-if="
                                                                feedbackField.domain &&
                                                                feedbackField
                                                                    .domain
                                                                    .id &&
                                                                feedbackField.type ===
                                                                    fieldTypeConst.ALPHANUMERIC
                                                            "
                                                            class="row-divider"
                                                        ></div>
                                                        <!-- Domain Type -->
                                                        <div
                                                            v-if="
                                                                feedbackField.domain &&
                                                                feedbackField
                                                                    .domain
                                                                    .id &&
                                                                feedbackField.type ===
                                                                    fieldTypeConst.ALPHANUMERIC
                                                            "
                                                            class="keep-inline"
                                                        >
                                                            <label
                                                                class="text-left col-md-4"
                                                            >
                                                                Domeinwaarden
                                                                tonen middels
                                                            </label>
                                                            <div
                                                                class="float-right col-md-8"
                                                            >
                                                                <x-select
                                                                    :id="`${feedbackField.name}_domaintype`"
                                                                    :name="`${feedbackField.name}_domaintype`"
                                                                    v-model="
                                                                        feedbackField.domainType
                                                                    "
                                                                    @selected="
                                                                        $_domainTypeSelected(
                                                                            $event,
                                                                            feedbackField
                                                                        )
                                                                    "
                                                                    :options="
                                                                        domainTypeOptions
                                                                    "
                                                                    :state="
                                                                        !$_isStringNotEmpty(
                                                                            feedbackField.domainTypeErrorMessage
                                                                        )
                                                                    "
                                                                    :invalidMessage="
                                                                        feedbackField.domainTypeErrorMessage
                                                                    "
                                                                    :simpleMode="
                                                                        true
                                                                    "
                                                                >
                                                                </x-select>
                                                            </div>
                                                        </div>
                                                        <!-- Domain extendable -->
                                                        <div
                                                            v-if="
                                                                feedbackField.domain &&
                                                                feedbackField
                                                                    .domain
                                                                    .id &&
                                                                feedbackField.type ===
                                                                    fieldTypeConst.ALPHANUMERIC
                                                            "
                                                            class="keep-inline"
                                                        >
                                                            <label
                                                                class="text-left col-md-4"
                                                            >
                                                                {{
                                                                    $t(
                                                                        'labelDomainExtendable'
                                                                    )
                                                                }}
                                                            </label>
                                                            <div
                                                                class="float-right col-md-8"
                                                            >
                                                                <x-checkbox
                                                                    :name="`${feedbackField.name}_domainExtendable`"
                                                                    v-model="
                                                                        feedbackField.domainExtendable
                                                                    "
                                                                >
                                                                </x-checkbox>
                                                            </div>
                                                        </div>
                                                        <!-- Default value -->
                                                        <div
                                                            v-if="
                                                                $_showDefaultValue(
                                                                    feedbackField
                                                                )
                                                            "
                                                            class="row-divider"
                                                        ></div>
                                                        <div
                                                            v-if="
                                                                $_showDefaultValue(
                                                                    feedbackField
                                                                )
                                                            "
                                                        >
                                                            <div
                                                                class="keep-inline"
                                                            >
                                                                <label
                                                                    class="text-left col-md-4"
                                                                >
                                                                    {{
                                                                        $_getLabelDefaultValue(
                                                                            feedbackField
                                                                        )
                                                                    }}
                                                                </label>
                                                                <!-- Category -->
                                                                <div
                                                                    v-if="
                                                                        feedbackField.type ===
                                                                            fieldTypeConst.CATEGORY &&
                                                                        feedbackField.categories
                                                                    "
                                                                    class="float-right col-md-8"
                                                                >
                                                                    <x-select
                                                                        :id="`${feedbackField.name}_fieldValueCategory`"
                                                                        :name="`${feedbackField.name}_fieldValueCategory`"
                                                                        v-model="
                                                                            feedbackField.defaultValue
                                                                        "
                                                                        @selected="
                                                                            $_defaultCategoryValueSelected(
                                                                                $event,
                                                                                feedbackField
                                                                            )
                                                                        "
                                                                        :options="
                                                                            categoryOptions
                                                                        "
                                                                        :simpleMode="
                                                                            true
                                                                        "
                                                                    >
                                                                    </x-select>
                                                                </div>
                                                                <!-- Domain -->
                                                                <div
                                                                    v-if="
                                                                        (feedbackField.type ===
                                                                            fieldTypeConst.ALPHANUMERIC ||
                                                                            feedbackField.type ===
                                                                                fieldTypeConst.STATE) &&
                                                                        feedbackField.domain
                                                                    "
                                                                    class="float-right col-md-8"
                                                                >
                                                                    <x-select
                                                                        :id="`${feedbackField.name}_fieldValueDomain`"
                                                                        :name="`${feedbackField.name}_fieldValueDomain`"
                                                                        v-model="
                                                                            feedbackField.defaultValue
                                                                        "
                                                                        @selected="
                                                                            $_defaultDomainValueSelected(
                                                                                $event,
                                                                                feedbackField
                                                                            )
                                                                        "
                                                                        :options="
                                                                            $_domainTypeValueOptions(
                                                                                feedbackField
                                                                                    .domain
                                                                                    .keyvalues
                                                                            )
                                                                        "
                                                                        :simpleMode="
                                                                            true
                                                                        "
                                                                    >
                                                                    </x-select>
                                                                </div>
                                                                <!-- Text or date -->
                                                                <div
                                                                    v-if="
                                                                        (feedbackField.type ===
                                                                            fieldTypeConst.DATE ||
                                                                            feedbackField.type ===
                                                                                fieldTypeConst.ALPHANUMERIC ||
                                                                            feedbackField.type ===
                                                                                fieldTypeConst.STATE) &&
                                                                        !feedbackField.domain
                                                                    "
                                                                    class="float-right col-md-8"
                                                                >
                                                                    <x-input
                                                                        :id="`${feedbackField.name}_fieldValue`"
                                                                        :name="`${feedbackField.name}_fieldValue`"
                                                                        type="text"
                                                                        :invalidMessage="
                                                                            feedbackField.invalidFieldError
                                                                        "
                                                                        :state="
                                                                            feedbackField
                                                                                .invalidFieldError
                                                                                .length ===
                                                                            0
                                                                        "
                                                                        v-model="
                                                                            feedbackField.defaultValue
                                                                        "
                                                                        @input="
                                                                            $_validateDefaultValue(
                                                                                $event,
                                                                                feedbackField
                                                                            )
                                                                        "
                                                                        @blur="
                                                                            $_fieldValueValidate(
                                                                                feedbackField
                                                                            )
                                                                        "
                                                                        :placeholder="
                                                                            feedbackField.type ===
                                                                            fieldTypeConst.DATE
                                                                                ? placeholders.filterDateValue
                                                                                : placeholders.filterTextValue
                                                                        "
                                                                    >
                                                                    </x-input>
                                                                </div>
                                                                <!-- Expression (calculated field) -->
                                                                <div
                                                                    v-if="
                                                                        feedbackField.type ===
                                                                        fieldTypeConst.EXPRESSION
                                                                    "
                                                                    class="float-right col-md-8"
                                                                >
                                                                    <x-input
                                                                        :id="`${feedbackField.name}_fieldValue`"
                                                                        :name="`${feedbackField.name}_fieldValue`"
                                                                        type="text"
                                                                        :invalidMessage="
                                                                            feedbackField.invalidExpressionErrorMessage
                                                                        "
                                                                        :state="
                                                                            !$_isStringNotEmpty(
                                                                                feedbackField.invalidExpressionErrorMessage
                                                                            )
                                                                        "
                                                                        v-model="
                                                                            feedbackField.expression
                                                                        "
                                                                        @input="
                                                                            $_validateExpressionValue(
                                                                                $event,
                                                                                feedbackField
                                                                            )
                                                                        "
                                                                        :placeholder="
                                                                            $t(
                                                                                'placeholderExpression'
                                                                            )
                                                                        "
                                                                        required
                                                                    >
                                                                    </x-input>
                                                                </div>
                                                                <!-- number -->
                                                                <div
                                                                    v-if="
                                                                        feedbackField.type ===
                                                                        fieldTypeConst.NUMERIC
                                                                    "
                                                                    class="float-right col-md-8"
                                                                >
                                                                    <x-input
                                                                        :id="`${feedbackField.name}_fieldValue`"
                                                                        :name="`${feedbackField.name}_fieldValue`"
                                                                        type="number"
                                                                        :invalidMessage="
                                                                            feedbackField.invalidFieldError
                                                                        "
                                                                        :state="
                                                                            feedbackField
                                                                                .invalidFieldError
                                                                                .length ===
                                                                            0
                                                                        "
                                                                        v-model="
                                                                            feedbackField.defaultValue
                                                                        "
                                                                        @input="
                                                                            $_validateDefaultValue(
                                                                                $event,
                                                                                feedbackField
                                                                            )
                                                                        "
                                                                        @blur="
                                                                            $_fieldValueValidate(
                                                                                feedbackField
                                                                            )
                                                                        "
                                                                        :placeholder="
                                                                            placeholders.filterTextValue
                                                                        "
                                                                    >
                                                                    </x-input>
                                                                </div>
                                                                <!-- number with decimals -->
                                                                <div
                                                                    v-if="
                                                                        feedbackField.type ===
                                                                        fieldTypeConst.NUMERICWITHDECIMALS
                                                                    "
                                                                    class="float-right col-md-8"
                                                                >
                                                                    <x-input
                                                                        :id="`${feedbackField.name}_fieldValue`"
                                                                        :name="`${feedbackField.name}_fieldValue`"
                                                                        type="number"
                                                                        step="any"
                                                                        :invalidMessage="
                                                                            feedbackField.invalidFieldError
                                                                        "
                                                                        :state="
                                                                            feedbackField
                                                                                .invalidFieldError
                                                                                .length ===
                                                                            0
                                                                        "
                                                                        v-model="
                                                                            feedbackField.defaultValue
                                                                        "
                                                                        @input="
                                                                            $_validateDefaultValue(
                                                                                $event,
                                                                                feedbackField
                                                                            )
                                                                        "
                                                                        @blur="
                                                                            $_fieldValueValidate(
                                                                                feedbackField
                                                                            )
                                                                        "
                                                                        :placeholder="
                                                                            placeholders.filterTextValue
                                                                        "
                                                                    >
                                                                    </x-input>
                                                                </div>
                                                            </div>
                                                            <div
                                                                class="text-left col-md-4"
                                                            ></div>
                                                            <div
                                                                class="float-right col-md-8"
                                                                v-if="
                                                                    feedbackField.invisibleAndRequiredErrorMessage !==
                                                                    null
                                                                "
                                                            >
                                                                <span
                                                                    class="text-danger"
                                                                >
                                                                    {{
                                                                        feedbackField.invisibleAndRequiredErrorMessage
                                                                    }}
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div
                                                            class="row-divider"
                                                        ></div>
                                                        <!-- Max rows for alphanumeric -->
                                                        <div
                                                            v-if="
                                                                feedbackField.type ===
                                                                    fieldTypeConst.ALPHANUMERIC &&
                                                                feedbackField.domainId ===
                                                                    null
                                                            "
                                                            class="keep-inline"
                                                        >
                                                            <label
                                                                class="text-left col-md-4"
                                                            >
                                                                Aantal regels
                                                            </label>
                                                            <div
                                                                class="float-right col-md-8"
                                                            >
                                                                <x-input
                                                                    :id="`${feedbackField.name}_nrRows`"
                                                                    :name="`${feedbackField.name}_nrRows`"
                                                                    type="number"
                                                                    :state="
                                                                        !invalidMessageMaxLengthNrOfRows.length >
                                                                        0
                                                                    "
                                                                    :invalidMessage="
                                                                        invalidMessageMaxLengthNrOfRows
                                                                    "
                                                                    @input="
                                                                        $_validateMaxLengthNrOfRows
                                                                    "
                                                                    v-model="
                                                                        feedbackField.nrRows
                                                                    "
                                                                >
                                                                </x-input>
                                                            </div>
                                                        </div>
                                                        <!-- Max length -->
                                                        <div
                                                            v-if="
                                                                (((feedbackField.type ===
                                                                    fieldTypeConst.ALPHANUMERIC &&
                                                                    feedbackField.domain ===
                                                                        null) ||
                                                                    feedbackField.type ===
                                                                        fieldTypeConst.NUMERIC ||
                                                                    feedbackField.type ===
                                                                        fieldTypeConst.NUMERICWITHDECIMALS) &&
                                                                    feedbackField.type !==
                                                                        fieldTypeConst.EMAIL) ||
                                                                feedbackField.domainExtendable
                                                            "
                                                            class="keep-inline"
                                                        >
                                                            <label
                                                                class="text-left col-md-4"
                                                            >
                                                                Max. Lengte
                                                            </label>
                                                            <div
                                                                class="float-right col-md-8"
                                                            >
                                                                <x-input
                                                                    :id="`${feedbackField.name}_maxLength`"
                                                                    :name="`${feedbackField.name}_maxLength`"
                                                                    type="number"
                                                                    :state="
                                                                        !invalidMessageMaxLength.length >
                                                                        0
                                                                    "
                                                                    :invalidMessage="
                                                                        invalidMessageMaxLength
                                                                    "
                                                                    @input="
                                                                        $_validateMaxLength(
                                                                            $event,
                                                                            feedbackField
                                                                        )
                                                                    "
                                                                    v-model="
                                                                        feedbackField.maxLength
                                                                    "
                                                                >
                                                                </x-input>
                                                            </div>
                                                        </div>
                                                        <!-- Min Value-->
                                                        <div
                                                            v-if="
                                                                feedbackField.type ===
                                                                    fieldTypeConst.NUMERIC ||
                                                                feedbackField.type ===
                                                                    fieldTypeConst.NUMERICWITHDECIMALS
                                                            "
                                                            class="keep-inline"
                                                        >
                                                            <label
                                                                class="text-left col-md-4"
                                                            >
                                                                {{
                                                                    $t(
                                                                        'labelMinValue'
                                                                    )
                                                                }}
                                                            </label>
                                                            <div
                                                                class="float-right col-md-8"
                                                            >
                                                                <x-input
                                                                    :id="`${feedbackField.name}_minValue`"
                                                                    :name="`${feedbackField.name}_minValue`"
                                                                    type="number"
                                                                    :invalidMessage="
                                                                        feedbackField.invalidMinValueErrorMessage
                                                                    "
                                                                    :state="
                                                                        !$_isStringNotEmpty(
                                                                            feedbackField.invalidMinValueErrorMessage
                                                                        )
                                                                    "
                                                                    @input="
                                                                        $_validateMinValue(
                                                                            $event,
                                                                            feedbackField
                                                                        )
                                                                    "
                                                                    v-model="
                                                                        feedbackField.minValue
                                                                    "
                                                                >
                                                                </x-input>
                                                            </div>
                                                        </div>
                                                        <!-- Max Value-->
                                                        <div
                                                            v-if="
                                                                feedbackField.type ===
                                                                    fieldTypeConst.NUMERIC ||
                                                                feedbackField.type ===
                                                                    fieldTypeConst.NUMERICWITHDECIMALS
                                                            "
                                                            class="keep-inline"
                                                        >
                                                            <label
                                                                class="text-left col-md-4"
                                                            >
                                                                {{
                                                                    $t(
                                                                        'labelMaxValue'
                                                                    )
                                                                }}
                                                            </label>
                                                            <div
                                                                class="float-right col-md-8"
                                                            >
                                                                <x-input
                                                                    :id="`${feedbackField.name}_maxValue`"
                                                                    :name="`${feedbackField.name}_maxValue`"
                                                                    type="number"
                                                                    :invalidMessage="
                                                                        feedbackField.invalidMaxValueErrorMessage
                                                                    "
                                                                    :state="
                                                                        !$_isStringNotEmpty(
                                                                            feedbackField.invalidMaxValueErrorMessage
                                                                        )
                                                                    "
                                                                    @input="
                                                                        $_validateMaxValue(
                                                                            $event,
                                                                            feedbackField
                                                                        )
                                                                    "
                                                                    v-model="
                                                                        feedbackField.maxValue
                                                                    "
                                                                >
                                                                </x-input>
                                                            </div>
                                                        </div>
                                                    </b-collapse>
                                                </b-card>
                                            </div>
                                        </v-draggable>
                                        <b-link
                                            :id="`addFeedbackInputField`"
                                            :name="`addFeedbackInputField`"
                                            @click="
                                                $_addItem(
                                                    itemTypes.feedbackField
                                                )
                                            "
                                        >
                                            <em class="fa fa-plus"></em
                                            >&nbsp;Invoerveld toevoegen
                                        </b-link>
                                    </b-tab>
                                    <!--Stijlen-->
                                    <b-tab :title="$t('labelTabStyle')">
                                        <div
                                            role="tablist"
                                            v-for="(
                                                style, sindex
                                            ) in feedback.styles"
                                            :key="sindex"
                                        >
                                            <b-card no-body class="mb-1">
                                                <b-card-header
                                                    v-b-toggle="
                                                        `accordionStyle${style.id}`
                                                    "
                                                    header-tag="header"
                                                    class="p-1"
                                                    v-bind:class="{
                                                        'invalid-state':
                                                            style.hasStyleError
                                                    }"
                                                    role="tab"
                                                    data-toggle="collapse"
                                                >
                                                    <span>
                                                        Stijl ({{
                                                            style.minScale
                                                        }}
                                                        -
                                                        {{ style.maxScale }})
                                                    </span>
                                                </b-card-header>
                                                <b-collapse
                                                    v-bind:id="`accordionStyle${style.id}`"
                                                    visible
                                                    accordion="my-styleaccordion"
                                                    role="tabpanel"
                                                >
                                                    <b-card-body>
                                                        <div
                                                            class="form-row w-50"
                                                        >
                                                            <label
                                                                class="col-form-label"
                                                            >
                                                                {{
                                                                    $t(
                                                                        'scaleRange'
                                                                    )
                                                                }}
                                                            </label>
                                                            <label
                                                                class="col-form-label pl-0"
                                                                for="`slMinScale_${sindex}`"
                                                                >min</label
                                                            >
                                                            <div class="col">
                                                                <x-select
                                                                    :id="`slMinScale_${sindex}`"
                                                                    v-model="
                                                                        style.minScale
                                                                    "
                                                                    @selected="
                                                                        $_onSelectScale(
                                                                            style
                                                                        )
                                                                    "
                                                                    :options="
                                                                        scaleOptions
                                                                    "
                                                                    :simpleMode="
                                                                        true
                                                                    "
                                                                    :showDefaultOption="
                                                                        false
                                                                    "
                                                                >
                                                                </x-select>
                                                            </div>
                                                            <label
                                                                class="col-form-label"
                                                                for="`slMaxScale_${sindex}`"
                                                                >max</label
                                                            >
                                                            <div class="col">
                                                                <x-select
                                                                    :id="`slMaxScale_${sindex}`"
                                                                    v-model="
                                                                        style.maxScale
                                                                    "
                                                                    @selected="
                                                                        $_onSelectScale(
                                                                            style
                                                                        )
                                                                    "
                                                                    :options="
                                                                        scaleOptions
                                                                    "
                                                                    :simpleMode="
                                                                        true
                                                                    "
                                                                    :showDefaultOption="
                                                                        false
                                                                    "
                                                                >
                                                                </x-select>
                                                            </div>
                                                        </div>
                                                        <div
                                                            class="form-row w-50"
                                                        >
                                                            <label
                                                                class="col-form-label"
                                                            >
                                                                {{
                                                                    $t(
                                                                        'labelTextMaxScale'
                                                                    )
                                                                }}
                                                            </label>
                                                            <label
                                                                class="col-form-label pl-0"
                                                                for="`slTextMaxScale_${sindex}`"
                                                                >max</label
                                                            >
                                                            <div class="col">
                                                                <x-select
                                                                    :id="`slTextMaxScale_${sindex}`"
                                                                    v-model="
                                                                        style.textMaxScale
                                                                    "
                                                                    class="w-50"
                                                                    :options="
                                                                        textScaleOptions(
                                                                            style.minScale,
                                                                            style.maxScale
                                                                        )
                                                                    "
                                                                    :simpleMode="
                                                                        true
                                                                    "
                                                                    :showDefaultOption="
                                                                        true
                                                                    "
                                                                >
                                                                </x-select>
                                                            </div>
                                                        </div>
                                                        <b-tabs
                                                            content-class="mt-3"
                                                        >
                                                            <!--Tab Standaard-->
                                                            <b-tab
                                                                :title="
                                                                    tabTitleStandard
                                                                "
                                                            >
                                                                <default-style-tab
                                                                    :selectedStyle="
                                                                        style
                                                                    "
                                                                    :textAttributeOptions="
                                                                        feedback.feedbackFields
                                                                    "
                                                                    name="FbStStandard"
                                                                    :isWebFeedback="
                                                                        feedback.useInWebTheme
                                                                    "
                                                                    :inputFields="
                                                                        feedback.feedbackFields
                                                                    "
                                                                    :isFeedback="
                                                                        true
                                                                    "
                                                                    :geometryTypeArray="
                                                                        feedback.geometryTypeArray
                                                                    "
                                                                    :showTextAttribute="
                                                                        $_showTextAttribute
                                                                    "
                                                                    @reevaluatestyle="
                                                                        $_onReevaluateStyle
                                                                    "
                                                                    @updateTabIndex="
                                                                        $_onUpdateAdvancedStyleTabIndex
                                                                    "
                                                                >
                                                                </default-style-tab>
                                                            </b-tab>
                                                            <!--Tab Selectie -->
                                                            <b-tab
                                                                :title="
                                                                    tabTitleSelection
                                                                "
                                                            >
                                                                <style-tab
                                                                    :themeStyle="
                                                                        style
                                                                    "
                                                                    tabSelection="Selection"
                                                                    name="FbStSelection"
                                                                    :geometryTypeArray="
                                                                        feedback.geometryTypeArray
                                                                    "
                                                                >
                                                                </style-tab>
                                                            </b-tab>
                                                            <!--Tab Detail-->
                                                            <b-tab
                                                                :title="
                                                                    tabTitleDetail
                                                                "
                                                            >
                                                                <style-tab
                                                                    :themeStyle="
                                                                        style
                                                                    "
                                                                    tabSelection="Selected"
                                                                    name="FbStDetails"
                                                                    :geometryTypeArray="
                                                                        feedback.geometryTypeArray
                                                                    "
                                                                >
                                                                </style-tab>
                                                            </b-tab>
                                                        </b-tabs>
                                                    </b-card-body>
                                                </b-collapse>
                                            </b-card>
                                        </div>
                                    </b-tab>
                                    <!-- Advanced labels only in edit mode -->
                                    <b-tab
                                        v-if="editMode"
                                        :title="$t('labelAdvancedLabels')"
                                    >
                                        <advanced-labels-tab
                                            id="advancedLabelsTab"
                                            ref="advancedLabelTab"
                                            :feedback="feedback"
                                        >
                                        </advanced-labels-tab>
                                    </b-tab>
                                </b-tabs>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                </div>
                <br />
                <div class="col-xs-12 col-md-12">
                    <!-- Where Clause -->
                    <h4>Where Clause</h4>
                    <div class="form-group">
                        <b-table-simple fixed>
                            <b-thead>
                                <b-tr>
                                    <b-th>Invoerveld</b-th>
                                    <b-th>Operator</b-th>
                                    <b-th>Waarde</b-th>
                                    <b-th>Type</b-th>
                                    <b-th class="header-button">-</b-th>
                                </b-tr>
                            </b-thead>
                            <b-tbody>
                                <!-- Existing where-clauses -->
                                <b-tr
                                    v-for="(
                                        whereclause, windex
                                    ) in feedback.whereClauses"
                                    :key="windex"
                                >
                                    <b-th>{{ whereclause.field.alias }}</b-th>
                                    <b-th>{{
                                        $_displayWhereClauseOperatorDescription(
                                            whereclause.operator
                                        )
                                    }}</b-th>
                                    <b-th class="where-value">{{
                                        $_displayWhereClauseDomainValue(
                                            whereclause
                                        )
                                    }}</b-th>
                                    <b-th>{{
                                        $_displayWhereClauseTypeDescription(
                                            whereclause.type
                                        )
                                    }}</b-th>
                                    <b-th>
                                        <base-button
                                            :id="`${windex}removeWhereClauseFilter`"
                                            @click="
                                                $_removeItem(
                                                    windex,
                                                    itemTypes.whereClause,
                                                    feedback.whereClauses
                                                )
                                            "
                                            :iconClass="`fa fa-times`"
                                        >
                                        </base-button>
                                    </b-th>
                                </b-tr>
                                <!-- Input for new where-clauses -->
                                <b-tr>
                                    <!-- Feedbackfield input -->
                                    <b-th>
                                        <b-form-select
                                            id="whereClausesFBInput"
                                            v-model="whereSelectedField"
                                            @change="$_feedbackNameSelected"
                                            :options="
                                                $_whereClauseOptions(
                                                    feedback.feedbackFields
                                                )
                                            "
                                        >
                                            <template v-slot:first>
                                                <option :value="null">
                                                    {{
                                                        $t(
                                                            'selectBoxMakeChoice'
                                                        )
                                                    }}
                                                </option>
                                            </template>
                                        </b-form-select>
                                    </b-th>
                                    <!-- Operator input -->
                                    <b-th>
                                        <b-form-select
                                            id="whereClausesOperatorInput"
                                            v-model="where.selectedoperator"
                                            :options="
                                                whereClauseOperatorsOptions
                                            "
                                        >
                                        </b-form-select>
                                    </b-th>
                                    <!-- Value input -->
                                    <b-th>
                                        <!-- Normal attribute for text input-->
                                        <x-input
                                            :id="'inputWhereValue'"
                                            :name="'inputWhereValue'"
                                            v-show="
                                                !(
                                                    where.selectedField &&
                                                    where.selectedField.domain
                                                )
                                            "
                                            v-model="where.value"
                                            @input="
                                                $_validateWhere(
                                                    where.selectedField,
                                                    where.value
                                                )
                                            "
                                            :state="
                                                feedbackFieldError.length === 0
                                            "
                                            :placeholder="
                                                $_placeholderInputWhereValue(
                                                    where.selectedField
                                                )
                                            "
                                        >
                                        </x-input>
                                        <!-- Domain attribute for select options-->
                                        <b-form-select
                                            id="whereClausesDomainAttr"
                                            v-if="
                                                where.selectedField &&
                                                where.selectedField.domain &&
                                                !(
                                                    where.selectedoperator ===
                                                    'C'
                                                )
                                            "
                                            v-model="where.value"
                                            :options="
                                                $_convertToValueTextPair(
                                                    where.selectedField.domain
                                                        .keyvalues,
                                                    'key',
                                                    'value'
                                                )
                                            "
                                        >
                                            <template v-slot:first>
                                                <option :value="''">
                                                    {{
                                                        $t(
                                                            'selectBoxMakeChoice'
                                                        )
                                                    }}
                                                </option>
                                            </template>
                                        </b-form-select>
                                        <!-- Domain attribute for suggestion list options-->
                                        <x-datalist
                                            :id="'whereClausesDomainSuggestion'"
                                            :name="'whereClausesDomainSuggestion'"
                                            v-if="
                                                where.selectedField &&
                                                where.selectedField.domain &&
                                                where.selectedoperator === 'C'
                                            "
                                            :options="
                                                $_convertToValueTextPair(
                                                    where.selectedField.domain
                                                        .keyvalues,
                                                    'key',
                                                    'value'
                                                )
                                            "
                                            :maxlength="255"
                                            v-model="where.value"
                                            :simpleMode="true"
                                        >
                                        </x-datalist>
                                    </b-th>
                                    <!-- Type input -->
                                    <b-th>
                                        <b-form-select
                                            id="whereClausesTypeInput"
                                            v-model="where.type"
                                            @change="
                                                $_validateWhere(
                                                    where.selectedField,
                                                    where.value
                                                )
                                            "
                                            :options="
                                                $_convertToValueTextPair(
                                                    possibleWhereClauseTypes,
                                                    'code',
                                                    'description'
                                                )
                                            "
                                        >
                                            <template v-slot:first>
                                                <option :value="null">
                                                    {{
                                                        $t(
                                                            'selectBoxMakeChoice'
                                                        )
                                                    }}
                                                </option>
                                            </template>
                                        </b-form-select>
                                    </b-th>
                                    <!-- Add where-clause button -->
                                    <b-th>
                                        <base-button
                                            id="AddWhereClause"
                                            variant="primary"
                                            @click="
                                                $_addItem(itemTypes.whereClause)
                                            "
                                            :disabled="addWhereClauseBtnEnabled"
                                            :iconClass="`fa fa-check`"
                                        >
                                        </base-button>
                                    </b-th>
                                </b-tr>
                            </b-tbody>
                        </b-table-simple>
                        <div>
                            <span
                                v-show="feedbackFieldError.length > 0"
                                class="text-danger"
                                readonly
                                >{{ feedbackFieldError }}</span
                            >
                        </div>
                    </div>
                    <div class="sticky-bottom fixed-bottom">
                        <div class="btn-group" role="group">
                            <b-button
                                id="save_button"
                                name="save_button"
                                type="submit"
                                variant="primary"
                                :disabled="!saveButtonEnabled"
                                class="active"
                            >
                                {{ $t('btnSaveLabel') }}
                                <span
                                    :class="{
                                        'fa fa-check': !isSaving,
                                        'fas fa-sync fa-spin': isSaving
                                    }"
                                ></span>
                            </b-button>
                            <b-button
                                v-if="copyButtonShow"
                                id="copy_feedback_button"
                                name="copy_feedback_button"
                                @click="$_onCopyFeedback"
                                class="btn-space-5"
                                :disabled="isSaving || isDeleting"
                            >
                                {{ $t('btnCopyLabel') }}
                                <span class="fa fa-copy"></span>
                            </b-button>
                            <b-button
                                id="check_feedback_button"
                                name="check_feedback_button"
                                v-if="displayVerificationButton"
                                @click="$_checkFeedbackSynchronization"
                                class="btn-space-5"
                                :disabled="isSaving || isDeleting"
                            >
                                {{ $t('btnVerifyLabel') }}
                                <span
                                    :class="{
                                        'fa fa-flag': !isSynchronizing,
                                        'fas fa-sync fa-spin': isSynchronizing
                                    }"
                                ></span>
                            </b-button>
                            <b-button
                                id="cancel_button"
                                name="cancel_button"
                                @click="$_cancel"
                                class="btn-space-5"
                                :disabled="isSaving || isDeleting"
                            >
                                {{ $t('btnCancelLabel') }}
                                <span class="fas fa-times"></span>
                            </b-button>
                        </div>
                        <div
                            class="btn-group btn-space-10"
                            role="group"
                            v-show="editMode"
                        >
                            <b-button
                                v-if="!this.copyMode"
                                id="remove_button"
                                name="remove_button"
                                @click="$_delete"
                                :disabled="isSaving || isDeleting"
                            >
                                {{ $t('btnDeleteLabel') }}
                                <span
                                    :class="{
                                        'fa fa-trash-alt': !isDeleting,
                                        'fas fa-sync fa-spin': isDeleting
                                    }"
                                ></span>
                            </b-button>
                        </div>
                    </div>
                    <br />
                    <br />
                </div>
            </div>
        </b-form>
        <add-domain-modal
            :launchModal="launchDomainModal"
            @modal-generated-domain="$_onModalGeneratedDomain"
            @modal-domain-saved="$_onModalDomainSaved"
        >
        </add-domain-modal>
    </div>
</template>

<script>
    import { orderBy } from 'lodash';
    import { mapActions } from 'vuex';
    import {
        validateDate,
        validateNumber,
        validateStringForWordCharactersAndAtLeast3Chars,
        validateSqlName
    } from '../../services/utilities/validator';
    import {
        arraySortAscendingFunction,
        stringNotEmpty,
        arrayNotEmpty,
        convertToValueTextPair,
        capitalizeValue,
        nprogress,
        getVariablesFromString,
        evaluateNumericExpression
    } from '../../services/utilities';
    import {
        CONTENT_TYPE_ID,
        DOMAIN_TYPE,
        FIELD_TYPE,
        MAX_LENGTH_CONSTRAINTS,
        OPERATOR_TYPE,
        WHERECLAUSE_TYPE,
        ADVANCED_STYLE_TAB_INDEX
    } from '../../constants';

    import modalMixin from '../../components/Mixins/ModalMixin.vue';
    import xcheckbox from '../../components/BaseComponents/x-checkbox.vue';
    import xinput from '../../components/BaseComponents/x-input.vue';
    import XSelect from '../../components/BaseComponents/x-select.vue';
    import XDatalist from '../../components/BaseComponents/x-datalist.vue';
    import styleTab from '../../components/dashboard/StylingOptions/StyleTab.vue';
    import defaultStyleTab from '../../components/dashboard/StylingOptions/DefaultStyleTab.vue';
    import AddDomainModal from '../../components/AddDomainModal.vue';
    import BaseButton from '../../components/BaseComponents/base-button.vue';
    import refcodeMixin from '../../components/Mixins/Refcodes/refcodeMixin.vue';
    import AdvancedLabelsTab from '../../components/dashboard/ViewRelatedComponents/AdvancedLabelsTab.vue';
    import draggable from 'vuedraggable';
    import { cleanData } from '../../services/api/patch';

    export default {
        name: 'FeedbackDetail',
        mixins: [modalMixin, refcodeMixin],

        components: {
            'x-checkbox': xcheckbox,
            'x-input': xinput,
            'x-select': XSelect,
            'x-datalist': XDatalist,
            'base-button': BaseButton,
            'v-draggable': draggable,
            'style-tab': styleTab,
            'default-style-tab': defaultStyleTab,
            'add-domain-modal': AddDomainModal,
            'advanced-labels-tab': AdvancedLabelsTab
        },

        props: {
            id: { type: Number, required: false, default: -1 },
            copyMode: { type: Boolean, required: false, default: false }
        },

        data: function () {
            return {
                // Constants
                contentTypeConst: CONTENT_TYPE_ID,
                fieldTypeConst: FIELD_TYPE,
                whereClauseTypeConst: WHERECLAUSE_TYPE,
                domainTypeConst: DOMAIN_TYPE,
                maxLengthConstraints: MAX_LENGTH_CONSTRAINTS,

                title: '',
                nameInvalidMessage: '',
                aliasInvalidMessage: '',
                name_alias: '',
                feedbackErrorMessage: '',
                feedbackFieldError: '',
                feedbackErrorMessagesList: [],
                invalidMessageMaxLength: '',
                invalidMessageMaxLengthNrOfRows: '',
                incorrectInputTitle: 'Invoer incorrect',
                isSaving: false,
                isDeleting: false,
                loading: false,
                editMode: false,
                errorInUse: false,
                invalidFormInput: false,
                itemTypes: {
                    style: 'stijl',
                    whereClause: 'where-clause',
                    feedbackField: 'invoerveld'
                },
                feedbackHasBeenSaved: false,
                feedbackHasBeenVerified: false,
                categoriesCalculated: false,
                isSynchronizing: false,
                isCopying: false,
                layerAvailable: true,
                nameError: false,
                aliasError: false,
                fbFieldsAllowed: true,
                launchDomainModal: false,
                currentFeedbackField: null,
                catetoryState: null,
                savedFeedbackField: null,
                tabTitleStandard: '',
                tabTitleSelection: '',
                tabTitleDetail: '',
                feedback: {},
                availableScaleItems: [],
                categories: [],
                allPossiblefields: [],
                possiblefields: [],
                domainTypes: [],
                domains: [],
                domainsWithKeyValuesDict: {},
                possibleOperators: [],
                possibleWhereClauseTypes: [],
                originalFeedbackFields: [],
                originalGeometryType: [],
                categoryOptions: [],
                advancedStyleTabIndex: ADVANCED_STYLE_TAB_INDEX.TAB_CLUSTER,
                userInfo: {
                    hasWebLicense:
                        this.$store.getters.userInfo.licenses.has_web_license,
                    hasMobileLicense:
                        this.$store.getters.userInfo.licenses.has_mobile_license,
                    isSuper: this.$store.getters.userInfo.isSuper,
                    organizationId: this.$store.getters.userInfo.organizationId
                },
                reservedFeedbackFields: [
                    'fid',
                    'geolocation',
                    'gpslocation',
                    'meldingsnummer',
                    'aansluitnummer',
                    'adres',
                    'aanmaker',
                    'aanmaakdatum',
                    'gewijzigddoor',
                    'wijzigingdatum',
                    'verwijderddoor',
                    'verwijderdatum',
                    'length',
                    'area',
                    'coord_x',
                    'coord_y',
                    // postgresql reserved words
                    'all',
                    'analyse',
                    'analyze',
                    'and',
                    'any',
                    'array',
                    'as',
                    'asc',
                    'asymmetric',
                    'both',
                    'case',
                    'cast',
                    'check',
                    'collate',
                    'column',
                    'constraint',
                    'create',
                    'current_catalog',
                    'current_date',
                    'current_role',
                    'current_time',
                    'current_timestamp',
                    'current_user',
                    'default',
                    'deferrable',
                    'desc',
                    'distinct',
                    'do',
                    'else',
                    'end',
                    'except',
                    'false',
                    'fetch',
                    'for',
                    'foreign',
                    'from',
                    'grant',
                    'group',
                    'having',
                    'in',
                    'initially',
                    'intersect',
                    'into',
                    'lateral',
                    'leading',
                    'limit',
                    'localtime',
                    'localtimestamp',
                    'not',
                    'null',
                    'offset',
                    'on',
                    'only',
                    'or',
                    'order',
                    'placing',
                    'primary',
                    'references',
                    'returning',
                    'select',
                    'session_user',
                    'some',
                    'symmetric',
                    'table',
                    'then',
                    'to',
                    'trailing',
                    'true',
                    'union',
                    'unique',
                    'user',
                    'using',
                    'variadic',
                    'when',
                    'where',
                    'window',
                    'with'
                ],
                extraMeasureFields: [
                    { name: 'length', alias: 'Lengte' },
                    { name: 'area', alias: 'Oppervlakte' },
                    { name: 'coord_x', alias: 'X-coördinaat' },
                    { name: 'coord_y', alias: 'Y-coördinaat' }
                ],
                // WHERE values
                where: {
                    selectedoperator: '=',
                    selectedField: null,
                    value: '',
                    type: ''
                },
                generalRequiredFields: [
                    { fieldName: 'name', textName: 'naam', plural: false },
                    { fieldName: 'alias', textName: 'alias', plural: false },
                    {
                        fieldName: 'keywords',
                        textName: 'trefwoorden',
                        plural: true
                    },
                    {
                        fieldName: 'geometryType',
                        textName: 'geometriesoort',
                        plural: false
                    }
                ],
                placeholders: {
                    filterTextValue: this.$t('labelDefaultValue'),
                    filterDateValue: 'dd-mm-jjjj'
                },
                accordionIndex: 0,
                intRegex: /^[-+]?\d+$/,
                defaultValueAlphanumericField: 100,
                maxNumberOfFeedbackErrors: 3,
                contentTypeOptions: [
                    { value: CONTENT_TYPE_ID.FEEDBACK, text: this.$t('feedback') },
                    {
                        value: CONTENT_TYPE_ID.MEASUREMENT,
                        text: this.$t('labelMeasure')
                    }
                ],
                originalSendStatusUpdates: false
            };
        },

        computed: {
            hasPhotoFields() {
                return this.feedback.feedbackFields.some(
                    (f) => f.type === this.fieldTypeConst.FOTO
                );
            },
            hasLineOrPolygonType() {
                let containsL = this.feedback.geometryType.includes('L');
                let containsV = this.feedback.geometryType.includes('V');
                return containsL || containsV;
            },
            addWhereClauseBtnEnabled() {
                return (
                    !this.$_validateWhereInput() ||
                    this.feedbackFieldError.length > 0
                );
            },

            displayVerificationButton() {
                return this.userInfo.isSuper && this.editMode && !this.copyMode;
            },

            domainTypeOptions() {
                return convertToValueTextPair(
                    this.domainTypes,
                    'code',
                    'description'
                );
            },

            domainOptions() {
                if (this.domains.length > 0) {
                    const orderedDomains = orderBy(this.domains, [
                        (domain) => domain.name.toLowerCase()
                    ]);
                    return convertToValueTextPair(orderedDomains, 'id', 'name');
                }
                return [];
            },

            scaleOptions() {
                return this.$_convertToValueTextPair(
                    this.availableScaleItems,
                    'scale',
                    'scale'
                );
            },

            textScaleOptions() {
                return (minScale, maxScale) => {
                    return this.scaleOptions.filter(
                        ({ value }) => value >= minScale && value <= maxScale
                    );
                };
            },

            /**
             * Check if Feedback can be saved
             * @returns {boolean} indicating if feedback can be saved
             */
            saveButtonEnabled() {
                return (
                    !this.isSaving &&
                    !this.isDeleting &&
                    !this.isSynchronizing &&
                    !this.nameInvalidMessage
                );
            },

            /**
             * Check if Feedback can be copied
             * @returns {boolean} indicating if feedback can be copied
             */
            copyButtonShow() {
                return this.id > 0 && !this.copyMode;
            },

            orderedFeedbackFields() {
                // FeedbackFields are already orded on Order propery from back-end
                return this.feedback.feedbackFields;
            },

            whereClauseOperatorsOptions() {
                let possibleOperators = [];
                if (
                    this.where.selectedField &&
                    this.where.selectedField.possibleOperators
                ) {
                    possibleOperators = convertToValueTextPair(
                        this.where.selectedField.possibleOperators,
                        'code',
                        'description'
                    );
                }
                possibleOperators.unshift({
                    text: this.$t('selectBoxMakeChoice'),
                    value: null
                });
                return possibleOperators;
            },

            whereSelectedField: {
                get() {
                    return this.where.selectedField && this.where.selectedField.name
                        ? this.where.selectedField.name
                        : null;
                },
                set() {
                    // Vue needs this statement as a setter
                }
            },

            /**
             * Return true if this is a feedback used in a webtheme and this feedback is of type measurement
             */
            $_isUsedInWebAndMeasurement() {
                return (
                    this.feedback.useInWebTheme &&
                    this.feedback.contentTypeId ===
                        this.contentTypeConst.MEASUREMENT
                );
            },

            $_hasPointGeometry() {
                return this.feedback.geometryType?.includes('P');
            },

            $_feedbackNamePlainText() {
                return this.editMode && !this.copyMode;
            },

            $_showTextAttribute() {
                // show text attribute if there is no attribute selected in the advanced label tab.
                return !this.feedback.feedbackFields.some((i) => i.isTextAttribute);
            },

            $_hasMissingGeometryType() {
                // check if an option is switched off compared to the original version
                const missingGeometryType = this.originalGeometryType.filter(
                    (type) => {
                        return !this.feedback.geometryType.split('').includes(type);
                    }
                );
                return this.editMode && missingGeometryType.length > 0;
            }
        },

        async created() {
            this.loading = true;
            await this.$_initFeedbackAttributeData();

            if (this.id > 0) {
                this.editMode = true;
                this.title = this.copyMode
                    ? this.$t('storageLayerCopyTitle')
                    : this.$t('storageLayerEditTitle');
                this.$_getFeedback(this.copyMode);
            } else {
                this.editMode = false;
                this.title = this.$t('storageLayerAddTitle');
                this.$_createFeedback();
            }

            if (!this.editMode) {
                // Add default style
                this.$_addItem(this.itemTypes.style);
            }
            if (!this.editMode && this.feedback.useInWebTheme) {
                this.$_onChangeUseInWebTheme(this.feedback.useInWebTheme);
            }
            // preload SVG file list for use in SVG based styles
            this.$_setAvailableSvgFiles();
        },

        mounted() {
            this.tabTitleStandard = this.$t('tabTitleStandard');
            this.tabTitleSelection = this.$t('tabTitleSelection');
            this.tabTitleDetail = this.$t('tabTitleDetail');
        },

        methods: {
            ...mapActions(['getOrganizationSetting']),
            $_onSelectScale(style) {
                // reset scale for text when min/max scale for layer is changed
                style.textMaxScale = null;
            },
            $_convertToValueTextPair(inputArray, key, value) {
                return convertToValueTextPair(inputArray, key, value);
            },
            async $_setAvailableSvgFiles() {
                await this.$store.dispatch('setAvailableSvgFiles');
            },

            $_isStringNotEmpty(str) {
                return stringNotEmpty(str);
            },

            $_isEditModeOrGenericType(feedbackField) {
                return (
                    (this.editMode && feedbackField.newi !== true) ||
                    feedbackField.type === this.fieldTypeConst.GENERIC
                );
            },

            $_getDefaultOptionDomain(feedbackField) {
                const required =
                    feedbackField.type === this.fieldTypeConst.STATE
                        ? ''
                        : this.$t('labelOptional');
                return `${this.$t('selectBoxMakeChoice')}${required}`;
            },

            $_getLabelDefaultValue(feedbackField) {
                if (feedbackField.type === this.fieldTypeConst.EXPRESSION) {
                    return this.$t('labelExpression');
                }

                const required = feedbackField.visible
                    ? this.$t('labelOptional')
                    : '';
                return `${this.$t('labelDefaultValue')}${required}`;
            },

            /**
             * Add the complete list of categories to the feedback field
             * @param {*} feedbackField, object to which the categories are added
             */
            $_addAllCategoriesToFeedbackField(feedbackField) {
                // create new array for all categories
                feedbackField.categories = [];
                // add all categories to the array
                for (const category of this.categories) {
                    feedbackField.categories.push({
                        categoryLookupId: 0,
                        id: category.id,
                        name: category.name,
                        adminEmail: category.adminEmail,
                        selected: false
                    });
                }
            },

            /**
             * Get a unique id for the new collapsable field header, otherwise all headers will be toggled open
             */
            $_getUniqueId() {
                this.accordionIndex++;
                return `Id${this.accordionIndex}`;
            },

            /**
             * Stijl, Invoerveld of Where clause toevoegen
             * @param {string} type The type
             */
            async $_addItem(type) {
                switch (type) {
                    case this.itemTypes.style: {
                        if (this.feedback.styles === null) {
                            this.feedback.styles = [];
                        }
                        const rgbaValueDefault = 'rgba(0, 0, 0, 1)';
                        const defaultFillColorSelection =
                            (await this.getOrganizationSetting({
                                name: 'FillColorSelection'
                            })) ?? 'rgba(255, 0, 0, 0.65)';
                        const defaultFillColorSelected =
                            (await this.getOrganizationSetting({
                                name: 'FillColorSelected'
                            })) ?? 'rgba(255, 255, 0, 0.65)';
                        const defaultStrokeColorSelection =
                            (await this.getOrganizationSetting({
                                name: 'StrokeColorSelection'
                            })) ?? rgbaValueDefault;
                        const defaultStrokeColorSelected =
                            (await this.getOrganizationSetting({
                                name: 'StrokeColorSelected'
                            })) ?? rgbaValueDefault;
                        const textFontDefaultValue = 'Arial, Helvetica, sans-serif';
                        const styleItem = {
                            id: this.$_getUniqueId(),
                            // Set default to 23.4375
                            minScale: this.availableScaleItems[19]
                                ? this.availableScaleItems[19].scale
                                : this.availableScaleItems[
                                      this.availableScaleItems.length - 1
                                  ].scale,
                            // Set default to 12000
                            maxScale: this.availableScaleItems[10]
                                ? this.availableScaleItems[10].scale
                                : this.availableScaleItems[0].scale,
                            textMaxScale: null,
                            // default
                            fillColorDefault: 'rgba(0, 0, 255, 0.25)',
                            strokeColorDefault: rgbaValueDefault,
                            pointSizeDefault: 5,
                            strokeWidthDefault: 1,
                            // txt
                            textFillColorDefault: rgbaValueDefault,
                            textStrokeColorDefault: 'rgba(255, 255, 255, 1)',
                            textStrokeWidthDefault: 1,
                            textFontDefault: textFontDefaultValue,
                            textFontSizeDefault: 12,
                            iconDefault: null,
                            iconDefaultFile: null,
                            // selection
                            fillColorSelection: defaultFillColorSelection,
                            strokeColorSelection: defaultStrokeColorSelection,
                            pointSizeSelection: 5,
                            strokeWidthSelection: 2,
                            iconSelection: null,
                            iconSelectionFile: null,
                            // selected
                            fillColorSelected: defaultFillColorSelected,
                            strokeColorSelected: defaultStrokeColorSelected,
                            pointSizeSelected: 5,
                            strokeWidthSelected: 2,
                            iconSelected: null,
                            iconSelectedFile: null,
                            customStylingOptions: null,
                            hasStyleError: false,
                            hasAdvancedStyleError: false
                        };
                        this.$_scaleToResolution(styleItem);
                        this.feedback.styles.push(styleItem);
                        break;
                    }
                    case this.itemTypes.feedbackField: {
                        if (this.feedback.feedbackFields === null) {
                            this.feedback.feedbackFields = [];
                        }

                        const newFeedbackField = {
                            newi: true,
                            id: this.$_getUniqueId(),
                            field_is_open: true,
                            domainType: null,
                            domainId: null,
                            domain: null,
                            type: null,
                            name: '',
                            alias: '',
                            visible: true,
                            tableView: true,
                            detailView: true,
                            popUp: true,
                            personalData: false,
                            required: false,
                            exportable: true,
                            print: true,
                            searchType: false,
                            domainExtendable: false,
                            invalidFieldValue: null,
                            invalidFieldError: '',
                            invisibleAndRequiredErrorMessage: null,
                            invalidFieldNameErrorMessage: '',
                            invalidFieldAliasErrorMessage: '',
                            domainTypeErrorMessage: '',
                            typeErrorMessage: '',
                            IsTextAttribute: false,
                            TextAttributeShowLabel: false,
                            TextAttributeLabel: null,
                            TextAttributeSeparator: null,
                            TextAttributeOrder: 0
                        };
                        this.$_addAllCategoriesToFeedbackField(newFeedbackField);
                        this.currentFeedbackField = newFeedbackField;

                        this.feedback.feedbackFields.push(newFeedbackField);
                        this.$_updatePossiblefields();
                        break;
                    }
                    case this.itemTypes.whereClause:
                        if (this.feedback.whereClauses === null) {
                            this.feedback.whereClauses = [];
                        }

                        // Add to list
                        this.feedback.whereClauses.push({
                            id: this.$_getUniqueId(),
                            field: this.where.selectedField,
                            operator: this.where.selectedoperator,
                            value: this.where.value,
                            // if the useInWebTheme is false then where.type is undefined.
                            // In this case set the type to explicit FILTER (F)
                            type:
                                this.where.type || this.whereClauseTypeConst.FILTER
                        });

                        // Clear input
                        this.$_setDefaultWhereClauseInput();
                        break;
                }
            },

            /**
             * Checks if the given feedbackalias already exists in the database
             * @return {void} - Sets error message if needed
             */
            async $_checkLayerAlias() {
                // Set aliasError initially to false until the opposite is true
                this.aliasError = false;
                if (this.$_hasErrorInAlias(false)) {
                    return;
                }
                const feedbackAliasExistsParams = {
                    alias: this.feedback.alias,
                    feedbackId:
                        this.feedback.id !== undefined ? this.feedback.id : 0
                };

                const result = await this.$store.dispatch('useApiData', {
                    name: 'GetAliasExists',
                    parameters: feedbackAliasExistsParams
                });

                if (result) {
                    this.aliasInvalidMessage = this.$t(
                        'feedbackAliasExistsErrorMessage'
                    );
                    this.invalidFormInput = result.data;
                    this.aliasError = result.data;
                }
            },

            $_calculateMinMaxScale() {
                if (this.feedback?.styles) {
                    for (let style of this.feedback.styles) {
                        this.$_resolutionToScale(style);
                    }
                }
            },

            $_cancel() {
                this.$_gotoOverview();
            },

            $_gotoOverview() {
                this.$router.push('/dashboard/feedbacks');
            },

            /**
             * Change default values for checkboxes
             * @param {string} fieldName name of the field
             * @param {booelan} isChecked indication true/false if checkboxes must be checked or not
             */
            $_changeCheckboxDefaultValues(fieldName, isChecked) {
                this.feedback.feedbackFields.forEach((field) => {
                    if (field.name === fieldName) {
                        field.tableView = isChecked;
                        field.detailView = isChecked;
                        field.popUp = isChecked;
                    }
                });
            },

            /**
             * Change default values for exportable and print property of desired field
             * @param {string} fieldName name of the field
             * @param {booelan} input indication true/false if checkboxes must be checked or not
             */
            $_setExportAndPrintDefaultValue(fieldName, input) {
                const foundedField = this.feedback.feedbackFields.find(
                    (feedbackField) => feedbackField.name === fieldName
                );
                if (foundedField) {
                    foundedField.exportable = input;
                    foundedField.print = input;
                }
            },

            /**
             * Check current feedback synchronization
             * Success if all feedbackfields are synchronized across SQL Server, PostGresQL & GeoServer
             */
            async $_checkFeedbackSynchronization() {
                // Force focus on invalid form inputs
                if (!this.$refs.feedbackform.checkValidity()) {
                    this.$refs.feedbackform.reportValidity();
                }

                this.feedbackHasBeenVerified = true;
                this.isSynchronizing = true;

                // Check for errors before running synchronization check
                if (this.$_hasAnyError()) {
                    this.isSynchronizing = false;
                    return;
                }

                // CheckFeedbackParams in C# code
                const checkFeedbackParams = { feedbackId: this.feedback.id };

                // Call API to check feedback synchronization
                const result = await this.$store.dispatch('useApiData', {
                    name: 'GetSynchronizedFeedbacks',
                    parameters: checkFeedbackParams
                });

                if (result) {
                    this.isSynchronizing = false;
                    // Feedback synchronization correct
                    if (result.data.length === 0) {
                        const data = {
                            message: 'Opslaglaag attributen lopen synchroon.',
                            variant: 'success',
                            autoHideDelay: 5000,
                            noCloseButton: true
                        };
                        this.showToast(data);
                        // Feedback synchronization incorrect
                    } else {
                        this.isSynchronizing = false;
                        const data = {
                            message: `Een aantal invoervelden zijn niet correct opgeslagen: ${result.data.join(
                                ', '
                            )}`,
                            variant: 'danger',
                            title: 'Opslaglaag invoervelden',
                            autoHideDelay: 10000
                        };
                        this.showToast(data);
                    }
                }
            },
            /**
             * Creates a new feedback object, filled with mandatory attributes
             * @returns {object} feedback - the new feedback object
             */
            $_createFeedback() {
                let newFeedback = {};
                this.$_getCategories();
                newFeedback = {};
                newFeedback.name = '';
                newFeedback.alias = '';
                newFeedback.name_alias = '';
                newFeedback.contentTypeId = this.contentTypeConst.FEEDBACK;
                newFeedback.geometryType = '';
                newFeedback.styles = [];
                newFeedback.feedbackFields = [];
                newFeedback.whereClauses = [];
                newFeedback.exportable = true;
                newFeedback.print = true;
                newFeedback.personal = true;
                // default use in web-theme is depending on license
                newFeedback.useInWebTheme =
                    this.userInfo.hasWebLicense && !this.userInfo.hasMobileLicense;
                // may change in a new layer
                //$scope.useInWebThemeEnabled = this.$store.getters.userInfo.licenses.has_mobile_license;

                // Add generic fields
                const genericFeedbackFields = this.$_getGenericFeedbackFields();
                for (const genericFeedbackField of genericFeedbackFields) {
                    newFeedback.feedbackFields.push(genericFeedbackField);
                }
                this.feedback = Object.assign({}, newFeedback);
                this.loading = false;
            },

            $_getGenericFeedbackFields() {
                // Default list with generic fields
                const genericFeedbackFields = [];

                // Add more generic fields if you like
                genericFeedbackFields.push({
                    id: this.$_getUniqueId(),
                    name: 'aanmaker',
                    alias: 'Aanmaker',
                    type: this.fieldTypeConst.GENERIC,
                    field_is_open: false,
                    tableView: true,
                    detailView: true,
                    popUp: true,
                    exportable: true,
                    print: true,
                    IsTextAttribute: false,
                    TextAttributeShowLabel: false,
                    TextAttributeLabel: null,
                    TextAttributeSeparator: null,
                    TextAttributeOrder: 0
                });
                genericFeedbackFields.push({
                    id: this.$_getUniqueId(),
                    name: 'aanmaakdatum',
                    alias: 'Aanmaakdatum',
                    type: this.fieldTypeConst.GENERIC,
                    field_is_open: false,
                    tableView: true,
                    detailView: true,
                    popUp: true,
                    exportable: true,
                    print: true,
                    IsTextAttribute: false,
                    TextAttributeShowLabel: false,
                    TextAttributeLabel: null,
                    TextAttributeSeparator: null,
                    TextAttributeOrder: 0
                });
                genericFeedbackFields.push({
                    id: this.$_getUniqueId(),
                    name: 'gewijzigddoor',
                    alias: 'Gewijzigd door',
                    type: this.fieldTypeConst.GENERIC,
                    field_is_open: false,
                    exportable: false,
                    print: false,
                    IsTextAttribute: false,
                    TextAttributeShowLabel: false,
                    TextAttributeLabel: null,
                    TextAttributeSeparator: null,
                    TextAttributeOrder: 0
                });
                genericFeedbackFields.push({
                    id: this.$_getUniqueId(),
                    name: 'wijzigingdatum',
                    alias: 'Wijziging datum',
                    type: this.fieldTypeConst.GENERIC,
                    field_is_open: false,
                    exportable: false,
                    print: false,
                    IsTextAttribute: false,
                    TextAttributeShowLabel: false,
                    TextAttributeLabel: null,
                    TextAttributeSeparator: null,
                    TextAttributeOrder: 0
                });
                genericFeedbackFields.push({
                    id: this.$_getUniqueId(),
                    name: 'verwijderddoor',
                    alias: 'Verwijderd door',
                    type: this.fieldTypeConst.GENERIC,
                    field_is_open: false,
                    exportable: false,
                    print: false,
                    IsTextAttribute: false,
                    TextAttributeShowLabel: false,
                    TextAttributeLabel: null,
                    TextAttributeSeparator: null,
                    TextAttributeOrder: 0
                });
                genericFeedbackFields.push({
                    id: this.$_getUniqueId(),
                    name: 'verwijderdatum',
                    alias: 'Verwijder datum',
                    type: this.fieldTypeConst.GENERIC,
                    field_is_open: false,
                    exportable: false,
                    print: false,
                    IsTextAttribute: false,
                    TextAttributeShowLabel: false,
                    TextAttributeLabel: null,
                    TextAttributeSeparator: null,
                    TextAttributeOrder: 0
                });

                // Add extra fields for measure data
                this.extraMeasureFields.forEach((field) => {
                    genericFeedbackFields.push({
                        id: this.$_getUniqueId(),
                        name: field.name,
                        alias: field.alias,
                        type: this.fieldTypeConst.GENERIC,
                        field_is_open: false,
                        tableView: false,
                        detailView: false,
                        popUp: false,
                        exportable: false,
                        print: false
                    });
                });

                return genericFeedbackFields;
            },

            $_handelDeleteError(error) {
                let errorMessage = '';
                // Set custom errorMessage in case of ApiException thrown
                if (
                    error.response &&
                    error.response.data.message.includes(
                        'Fout bij het verwijderen van de opslaglaag'
                    )
                ) {
                    errorMessage = error.response.data.message;
                } else {
                    errorMessage = this.$t('deleteFailureMessage', [
                        `${error.message}`
                    ]);
                }

                const data = {
                    message: errorMessage,
                    variant: 'danger',
                    title: this.$t('deleteFailureTitle'),
                    autoHideDelay: 10000
                };
                this.showToast(data);
            },

            $_domainTypeSelected(event, feedbackField) {
                feedbackField.domainType = event;
                this.$_validDomainType(feedbackField);
            },

            $_defaultCategoryValueSelected(event, feedbackField) {
                feedbackField.defaultValue = event;
            },

            $_defaultDomainValueSelected(event, feedbackField) {
                feedbackField.defaultValue = event;
                this.$_hasErrorInFeedbackFields();
            },

            async $_delete() {
                const messageData = {
                    message: this.$t('feedbackCardDeletionsConfirmation')
                };
                this.msgBoxConfirm(messageData).then(async (confirm) => {
                    if (confirm) {
                        this.isDeleting = true;
                        this.feedback.organization_id =
                            this.userInfo.organizationId;
                        await this.$store
                            .dispatch('useApiData', {
                                name: 'IsFeedbackInUse',
                                parameters: { feedbackId: this.feedback.id }
                            })
                            .then(
                                async (inuse) => {
                                    if (inuse.data) {
                                        this.isDeleting = false;
                                        const data = {
                                            message: this.$t(
                                                'storageLayerInUseErrorMessage'
                                            ),
                                            variant: 'danger',
                                            autoHideDelay: 75000,
                                            noCloseButton: true
                                        };
                                        this.showToast(data);
                                    } else {
                                        try {
                                            const result =
                                                await this.$store.dispatch(
                                                    'useApiData',
                                                    {
                                                        name: 'DeleteFeedbackType',
                                                        parameters: {
                                                            Id: this.feedback.id
                                                        }
                                                    }
                                                );

                                            if (result) {
                                                this.isDeleting = false;
                                                this.$_gotoOverview();
                                            }
                                        } catch (error) {
                                            this.isDeleting = false;
                                            this.$_handelDeleteError(error);
                                        }
                                    }
                                },
                                (error) => {
                                    this.isDeleting = false;
                                }
                            );
                    }
                });
            },
            // determine if a delete button should be shown
            // This is true for all GENERIC fields
            // And it is true for the address field when creating a new feedback type.
            $_showDeleteButton(feedbackField) {
                return (
                    feedbackField.type !== this.fieldTypeConst.GENERIC ||
                    (feedbackField.name === 'adres' && this.id === -1)
                );
            },
            /**
             * Deletes feedback field if its domain is not in used
             * @param itemIndex index of selected item
             * @param array feedbackfield array
             * @param item field to delete
             */
            $_deleteFeedbackField(itemIndex, array, item) {
                const usedInExpressionsList = this.$_usedInExpressionList(item);

                if (this.$_hasDomainIsUsed(item)) {
                    const data = {
                        message: this.$t('fieldNotremovable'),
                        variant: 'danger',
                        noCloseButton: true,
                        autoHideDelay: 5000
                    };
                    this.showToast(data);
                } else if (usedInExpressionsList.length > 0) {
                    const data = {
                        message: this.$t('fieldNotRemovableExpression', [
                            usedInExpressionsList.join(',')
                        ]),
                        variant: 'danger',
                        noCloseButton: true,
                        autoHideDelay: 5000
                    };
                    this.showToast(data);
                } else {
                    const data = {
                        message: this.editMode
                            ? this.$t('feedbackCardInputDeletionsConfirmation')
                            : this.$t('feedbackCardTypeDeletionsConfirmation', [
                                  `${this.$t('prefix')}`,
                                  `${this.$t('inputfield')}`
                              ])
                    };

                    this.msgBoxConfirm(data).then((confirm) => {
                        if (confirm) {
                            array = this.$_removeField(itemIndex, array, item);
                            this.$_updatePossiblefields();
                        }
                    });
                }
            },

            /**
             * Display checkbox for contact-information only for WebFeedbacks where feedbackField type is alphanumeric (i.e. name), numeric (i.e. phone number) or email
             * @param feedbackField
             */
            $_displayContactInformationField(feedbackField) {
                if (
                    !this.feedback.useInWebTheme ||
                    this.feedback.contentTypeId ===
                        this.contentTypeConst.MEASUREMENT
                ) {
                    return false;
                }
                if (
                    feedbackField.type !== this.fieldTypeConst.ALPHANUMERIC &&
                    feedbackField.type !== this.fieldTypeConst.NUMERIC &&
                    feedbackField.type !==
                        this.fieldTypeConst.NUMERICWITHDECIMALS &&
                    feedbackField.type !== this.fieldTypeConst.EMAIL
                ) {
                    return false;
                }
                return true;
            },

            $_displayFeedbackErrorMessage() {
                return (
                    (this.feedbackHasBeenSaved || this.feedbackHasBeenVerified) &&
                    this.$_feedbacklayerHasError()
                );
            },

            /**
             * Returns the where-clause value for display
             * Returns a looked up domain-value if the current value is a domain code
             * @param {object} whereClause - the whereClause, which possibly has a value based on its domain
             * @returns {string} The display value for this where-clause value
             */
            $_displayWhereClauseDomainValue(whereClause) {
                // If value is a domain code, display the domain value
                if (
                    whereClause.field.domain &&
                    whereClause.field.domain.keyvalues.length > 0
                ) {
                    const correspondingKv = whereClause.field.domain.keyvalues.find(
                        (kv) => kv.key === whereClause.value
                    );
                    if (correspondingKv) {
                        return correspondingKv.value;
                    }
                }
                // Return regular value
                return whereClause.value;
            },

            /**
             * Returns the where-clause operator description for a given code (Contains = C)
             * @param {string} whereClauseOperator  - the whereClause operator as code (C, or =, <>, >, <, etc.)
             * @returns {string} The description (display name) for this operator code
             */
            $_displayWhereClauseOperatorDescription(whereClauseOperator) {
                // Only when possibleOperators is set
                if (this.possibleOperators && whereClauseOperator) {
                    return this.possibleOperators.find(
                        (o) => o.code === whereClauseOperator
                    ).description;
                }
                // Return code if lookup is not possible
                return whereClauseOperator;
            },

            /**
             * Returns the where-clause type description for a given code (Filter / Remove)
             * @param {string} whereclauseType - the whereClause type as code (F or R)
             * @returns {string} The description (display name) for this type code
             */
            $_displayWhereClauseTypeDescription(whereclauseType) {
                // Only when possibleWhereClauseTypes is set
                if (this.possibleWhereClauseTypes && whereclauseType) {
                    return this.possibleWhereClauseTypes.find(
                        (o) => o.code === whereclauseType
                    ).description;
                }
                // Return code if lookup is not possible
                return whereclauseType;
            },

            /**
             * Domain selection list changed event handler
             * @param {id} domainId selected domainId via on change event
             * @param {object} fieldItem current fieldItem object
             */
            $_domainSelected(domainId, fieldItem) {
                // Domain selected, empty fieldItem value
                fieldItem.defaultValue = '';
                fieldItem.nrRows = 1;
                if (domainId !== null) {
                    // Get details for selected domain
                    this.$_getDomainFromDict(domainId).then((result) => {
                        fieldItem.domain = result;
                    });
                } else {
                    fieldItem.domain = domainId;
                }
            },

            $_fbFieldNameAllowed(fieldItem) {
                let fieldNameExists = false;
                let fieldNameReserved = false;
                let fieldNameValid = true;
                // FeedbackField naam naar lowercase converteren
                fieldItem.name = fieldItem.name.toLowerCase();

                // Fill in Alias automatically
                if (fieldItem && fieldItem.newi) {
                    if (
                        !fieldItem.alias ||
                        fieldItem.alias === fieldItem.alias_name
                    ) {
                        fieldItem.alias = fieldItem.alias_name = capitalizeValue(
                            fieldItem.name
                        );
                    } else {
                        fieldItem.alias_name = fieldItem.name;
                    }
                    // Validate Alias property because its value is chenged
                    this.$_validateFieldAlias(fieldItem);
                }

                // PBI 10163 Check if name already exists
                // Do not compare with own feedbackfield
                // Check for both current and original (before deletion) feedbackfields
                const existingFields = this.feedback.feedbackFields.concat(
                    this.originalFeedbackFields
                );
                for (let existingField of existingFields) {
                    if (
                        existingField.id !== fieldItem.id &&
                        existingField.name === fieldItem.name
                    ) {
                        fieldNameExists = true;
                        fieldItem.invalidFieldNameErrorMessage =
                            'Deze naam bestaat al';
                        break;
                    }
                }

                if (this.reservedFeedbackFields.includes(fieldItem.name)) {
                    fieldNameReserved = true;
                }

                // Show.hide errormessage and disable/enable savebutton based on name exists / reserved
                fieldItem.nameExists = fieldNameExists;
                fieldItem.nameReserved = fieldNameReserved;

                if (!validateSqlName(fieldItem.name)) {
                    fieldItem.invalidFieldNameErrorMessage = this.$t(
                        'errorInvalidColumnName'
                    );
                    fieldNameValid = false;
                }

                // Set variable to check disabling save button
                this.fbFieldsAllowed =
                    !fieldNameExists && !fieldNameReserved && fieldNameValid;

                // Set invalid form variable when form input is false
                if (this.fbFieldsAllowed) {
                    this.$_validateFieldName(fieldItem);
                } else {
                    this.invalidFormInput = false;
                }
                this.$_feedbacklayerHasError();
            },

            /**
             * Determines whether the domain of the field is used in a advanced style
             * @param field
             */
            $_hasDomainIsUsed(field) {
                let fieldDomainIsUse = false;
                if (field.domain && field.domainId) {
                    const hasUsedDomain = this.feedback.styles.find(
                        (style) =>
                            style.customStylingOptions &&
                            style.customStylingOptions.domainId === field.domainId
                    );
                    if (hasUsedDomain) {
                        fieldDomainIsUse = true;
                    }
                }
                return fieldDomainIsUse;
            },

            // Determines whether a field is used in the expression of a calculated field.
            // returns a list of all calculated field names in which the field is being used in the expression.
            $_usedInExpressionList(field) {
                let usedInExpressionsList = [];

                // Get all calculated fields
                const calculatedFields = this.feedback.feedbackFields.filter(
                    (field) => field.type === this.fieldTypeConst.EXPRESSION
                );

                // For each calculation
                for (const calculatedField of calculatedFields) {
                    // get a list of variables used
                    var fieldNames = getVariablesFromString(
                        calculatedField.expression
                    );

                    // check if one of those variabloes is our field.
                    // If so add calculated field to the list
                    if (fieldNames.includes(field.name)) {
                        usedInExpressionsList.push(calculatedField.name);
                    }
                }

                return usedInExpressionsList;
            },

            $_feedbackFieldCategoryOptions(feedbackField) {
                if (feedbackField.categories) {
                    const filteredCategories = feedbackField.categories.filter(
                        (item) => {
                            return item.selected === true;
                        }
                    );

                    this.categoryOptions = convertToValueTextPair(
                        filteredCategories,
                        'name',
                        'name'
                    );
                    this.$_updateFieldDefaultValue(feedbackField);
                    this.$_validateCategory(feedbackField);
                }
                return this.categoryOptions;
            },

            /**
             * Show an error if:
             * - Feedback layer has no styles.
             *
             * @return     {boolean}  { description_of_the_return_value }
             */
            $_feedbacklayerHasError() {
                // Reset form input validation when appropriate
                if (
                    this.layerAvailable &&
                    !this.aliasError &&
                    this.fbFieldsAllowed
                ) {
                    this.invalidFormInput = false;
                }
                this.feedbackErrorMessagesList = [];

                const hasAliasError = this.$_hasErrorInAlias(true);
                const hasRequiredFieldsError = this.$_hasErrorInRequiredFields();
                const hasFeedbackFieldsError = this.$_hasErrorInFeedbackFields();
                const hasStylesError = this.$_hasErrorInStyles();
                const hasExpressionError = this.$_hasErrorInExpressionFields();

                let hasError =
                    this.nameError ||
                    hasAliasError ||
                    hasRequiredFieldsError ||
                    hasFeedbackFieldsError ||
                    hasStylesError ||
                    hasExpressionError ||
                    this.feedbackFieldError.length > 0;
                // If feedback has been saved or verified before, then validate the whole form
                if (this.feedbackHasBeenSaved || this.feedbackHasBeenVerified) {
                    if (!this.$refs.feedbackform.checkValidity()) {
                        this.feedbackErrorMessagesList.push({
                            message: 'Niet alle velden zijn ingevuld'
                        });
                        this.invalidFormInput = true;
                        hasError = true;
                    }
                }
                return hasError;
            },

            /**
             * Feedback invoerveld geselecteerd event handler
             * @param  {object} event        AngularJS event object
             * @param  {object} selectedField het geselecteerde invoerveld
             */
            $_feedbackNameSelected(event) {
                this.where.selectedField = this.feedback.feedbackFields.find(
                    (field) => {
                        return field.name === event;
                    }
                );
                // geen validatie op domein waarden
                if (this.where.selectedField && this.where.selectedField.type) {
                    switch (this.where.selectedField.type) {
                        case this.fieldTypeConst.GENERIC:
                            if (
                                this.where.selectedField.name === 'aanmaakdatum' ||
                                this.where.selectedField.name ===
                                    'wijzigingdatum' ||
                                this.where.selectedField.name === 'verwijderdatum'
                            ) {
                                // RLI: deze behandelen als een datumveld
                                this.where.selectedField.possibleOperators =
                                    this.possibleOperators.filter((o) =>
                                        ['>', '>=', '=', '<>', '<', '<='].includes(
                                            o.code
                                        )
                                    );
                            } else {
                                this.where.selectedField.possibleOperators =
                                    this.possibleOperators.filter((o) =>
                                        ['=', '<>', 'C'].includes(o.code)
                                    );
                            }
                            break;
                        case this.fieldTypeConst.ALPHANUMERIC:
                        case this.fieldTypeConst.STATE:
                            this.where.selectedField.possibleOperators =
                                this.possibleOperators.filter((o) =>
                                    ['=', '<>', 'C'].includes(o.code)
                                );
                            break;
                        case this.fieldTypeConst.NUMERIC:
                        case this.fieldTypeConst.NUMERICWITHDECIMALS:
                        // Fall Through
                        case this.fieldTypeConst.DATE:
                            this.where.selectedField.possibleOperators =
                                this.possibleOperators.filter((o) =>
                                    ['>', '>=', '=', '<>', '<', '<='].includes(
                                        o.code
                                    )
                                );
                            break;
                        case this.fieldTypeConst.CATEGORY:
                            this.where.selectedField.possibleOperators =
                                this.possibleOperators.filter((o) =>
                                    ['=', '<>'].includes(o.code)
                                );
                    }
                }
            },

            /**
             * An invisible field with no default value and required checked, is not allowed because the user cannot enter it
             * @param {object} field input field object
             * @return {boolean} true if field is allowed to be invisible
             */
            $_fieldIsAllowedToBeInvisibleAndRequired(field) {
                return !(
                    field.type !== this.fieldTypeConst.GENERIC &&
                    field.type !== this.fieldTypeConst.EXPRESSION &&
                    field.required &&
                    !field.visible &&
                    this.$_isUndefinedNullOrEmpty(field.defaultValue)
                );
            },

            /**
             * Validate value
             * @param {object} fieldItem current fieldItem object
             */
            $_fieldValueValidate(fieldItem) {
                // Date validation
                if (fieldItem.type === this.fieldTypeConst.DATE) {
                    if (validateDate(fieldItem.defaultValue, false)) {
                        fieldItem.invalidFieldValue = false;
                        fieldItem.invalidFieldError = '';
                    } else {
                        fieldItem.invalidFieldValue = true;
                        fieldItem.invalidFieldError = this.$t('labelInvalidDate');
                    }
                }
            },

            /**
             * Filter keywords on:
             * 1. empty entries
             * 2. multiple separators
             *
             * @return     {string}  filterd keywords list.
             */
            $_filterKeywords() {
                let keywords = '';
                // split keywords on ',', ';' and ' '
                const tokens = this.feedback.keywords.split(/[\s,; ]+/);
                const length = tokens.length;

                if (length > 0) {
                    for (let i = 0; i < length; i++) {
                        const token = tokens[i].trim();
                        if (token) {
                            if (keywords.length > 0) {
                                keywords = keywords.concat(',');
                            }
                            keywords = keywords.concat(token);
                        }
                    }
                }
                return keywords;
            },

            /**
             * Do not show option 'Generic' when new field is added
             * And do not show Category, State and Email when "Gebruik in Web themakaart" is checked
             * @param {bool} isNewField - is new field added yes or no?
             * @return {bool} filtered option
             */
            $_filterTypeOptions(isNewField) {
                // Check wether the filtering dependencies are valid
                let filteredData = [];

                if (isNewField) {
                    // Email is allowed when sending emails from web feedback
                    const allowEmail =
                        this.feedback.useInWebTheme &&
                        this.feedback.contentTypeId !==
                            this.contentTypeConst.MEASUREMENT;

                    // Category is allowed when sending emails from web feedback or mobile with status updates
                    const allowCategory =
                        (this.feedback.useInWebTheme &&
                            this.feedback.contentTypeId !==
                                this.contentTypeConst.MEASUREMENT) ||
                        this.feedback.sendStatusUpdates;

                    // State is allowed when sending email from feedback or from mobile whith SendStatusUpdates
                    // note: sendStatusUpdates is always false when type = measurement.
                    const allowState =
                        allowCategory || this.feedback.sendStatusUpdates;

                    // Allow all non generic fields except when that type is not allowed.
                    filteredData = this.possiblefields.filter((element) => {
                        return (
                            element.code !== this.fieldTypeConst.GENERIC &&
                            !(
                                (element.code === this.fieldTypeConst.STATE &&
                                    !allowState) ||
                                (element.code === this.fieldTypeConst.CATEGORY &&
                                    !allowCategory) ||
                                (element.code === this.fieldTypeConst.EMAIL &&
                                    !allowEmail)
                            )
                        );
                    });
                } else {
                    filteredData = this.possiblefields;
                }
                return filteredData;
            },

            async $_getAllDomains() {
                await this.$store
                    .dispatch('useApiData', {
                        name: 'GetFeedbackDomainOverview'
                    })
                    .then((result) => {
                        this.domains = Object.assign([], result.data);
                    });
            },

            async $_getAvailableScales() {
                await this.$store
                    .dispatch('useApiData', {
                        name: 'GetThemeScaleItems'
                    })
                    .then((scales) => {
                        this.availableScaleItems = Object.assign([], scales.data);
                    });
            },

            async $_getCategories() {
                await this.$store
                    .dispatch('useApiData', {
                        name: 'GetFeedbackCategories'
                    })
                    .then((result) => {
                        this.categories = Object.assign([], result.data);
                        // Do not calculate categories for empty feedback object
                        if (this.editMode && this.feedback.feedbackFields) {
                            for (const feedbackField of this.feedback
                                .feedbackFields) {
                                if (
                                    feedbackField.type ===
                                    this.fieldTypeConst.CATEGORY
                                ) {
                                    this.$_addAllCategoriesToFeedbackField(
                                        feedbackField
                                    );
                                    this.$_selectFeedbackFieldCategories(
                                        feedbackField
                                    );
                                    this.$_feedbackFieldCategoryOptions(
                                        feedbackField
                                    );
                                }
                            }
                        }
                        this.categoriesCalculated = true;
                    });
            },

            /**
             * Try to get domain inlcuding keyvalues from dict
             * If not present, retrieve it and store in dict
             * @param domainId - domainId of the domain to return
             * @returns {Promise} - promise object resolving the domain object
             */
            $_getDomainFromDict(domainId) {
                return new Promise((resolve, reject) => {
                    // If domain found, return it
                    const knownDomain = this.domainsWithKeyValuesDict[domainId];
                    if (knownDomain) {
                        resolve(knownDomain);
                    } else {
                        // Otherwise retrieve it from db and put in dict
                        this.$store
                            .dispatch('useApiData', {
                                name: 'GetFeedbackDomain',
                                parameters: { id: domainId }
                            })
                            .then((result) => {
                                resolve(result.data);
                            })
                            .catch((error) => {
                                reject(error);
                            });
                    }
                });
            },
            async $_getFeedback(feedbackCopyMode) {
                nprogress.start();

                // get existing ows data from the backend
                const result = await this.$store.dispatch('useApiData', {
                    name: 'GetFeedbackType',
                    parameters: { Id: this.id }
                });

                if (result) {
                    result.data.feedbackFields.forEach((field) => {
                        field.invalidFieldValue = null;
                        field.invalidFieldError = '';
                        field.invisibleAndRequiredErrorMessage = null;
                        field.invalidFieldNameErrorMessage = '';
                        field.invalidFieldAliasErrorMessage = '';
                        field.domainTypeErrorMessage = '';
                        field.invalidMinValueErrorMessage = '';
                        field.invalidMaxValueErrorMessage = '';
                        field.invalidMaxLengthErrorMessage = '';
                        field.invalidExpressionErrorMessage = '';
                    });
                    if (result.data.styles && result.data.styles.length > 0) {
                        result.data.styles.forEach((style) => {
                            style.hasStyleError = false;
                            style.hasAdvancedStyleError = false;
                            style.textMaxScale = null;
                        });
                    }
                    this.feedback = Object.assign({}, result.data);
                    // save database value to be able to check for change later.
                    this.originalSendStatusUpdates =
                        this.feedback.sendStatusUpdates;
                    this.$_calculateMinMaxScale();
                    this.$_getCategories();
                    this.$_preselectDomainsForAllFields();
                    // Remember original feedbackfields
                    this.originalFeedbackFields = JSON.parse(
                        JSON.stringify(this.feedback.feedbackFields)
                    );
                    // Remember original geometry type
                    this.originalGeometryType =
                        this.feedback.geometryType.split('');
                    // Set geometry types from feedback geometrytype code
                    this.$_getGeometryTypes();
                    this.$_addAddressField(null);
                    this.loading = false;

                    if (feedbackCopyMode) {
                        this.feedback.id = undefined;
                        this.feedback.name += this.$t('suffixUnderscoreCopy');
                        this.feedback.alias += this.$t('suffixHyphenCopy');
                    }

                    nprogress.done();
                }
            },

            /**
             * Get feedback geometry types
             */
            $_getGeometryTypes() {
                // Split geometry types to array for radio group model binding
                this.feedback.geometryTypeArray =
                    this.feedback.geometryType.split('');
            },

            /**
             * Verkrijg de niet correcte stijlen uit $scope.feedback.styles.
             * @return {array} array met niet correcte stijlen
             */
            $_getIncorrectStyles() {
                const incorrectStyles = [];
                const styles = this.feedback.styles;

                for (let style of styles) {
                    if (
                        this.$_hasInvalidAdvancedStyle(style) ||
                        this.$_isUndefinedNullOrEmpty(style.minScale) ||
                        this.$_isUndefinedNullOrEmpty(style.maxScale) ||
                        this.$_isUndefinedNullOrEmpty(style.strokeColorDefault)
                    ) {
                        incorrectStyles.push(style);
                    }
                }
                return incorrectStyles;
            },

            /**
             * Shows a info message when a new attribute is chosen for searchterm harvesting/searchType.
             * @param {bool} isHarvested the new boolean value indicating that the attribute is being harvested
             */
            $_harvestNotification(isHarvested) {
                if (isHarvested) {
                    const data = { message: this.$t('harvestMsg') };
                    this.showToast(data);
                }
            },

            $_hasInvalidResolution(style) {
                return (
                    this.$_isUndefinedNullOrEmpty(style.minResolution) ||
                    this.$_isUndefinedNullOrEmpty(style.maxResolution)
                );
            },

            $_hasInvalidScale(style) {
                return (
                    this.$_isUndefinedNullOrEmpty(style.minScale) ||
                    this.$_isUndefinedNullOrEmpty(style.maxScale)
                );
            },

            $_hasInvalidStrokeColor(style) {
                return (
                    this.$_isUndefinedNullOrEmpty(style.strokeColorDefault) ||
                    this.$_isUndefinedNullOrEmpty(style.strokeColorSelection) ||
                    this.$_isUndefinedNullOrEmpty(style.strokeColorSelected)
                );
            },

            $_hasAnyError() {
                const hasFeedbackLayerError = this.$_feedbacklayerHasError();
                const hasFeedbackStyleError = this.$_hasErrorInStyles();
                const hasOtherError = arrayNotEmpty(this.feedbackErrorMessagesList);
                // If isValid is false, feedbackErrorMessage is filled. Error is shown in form and save button is disabled
                return (
                    hasFeedbackLayerError || hasFeedbackStyleError || hasOtherError
                );
            },

            $_hasErrorInAlias(setMessage) {
                if (this.feedback.alias && this.feedback.alias.length < 3) {
                    this.aliasInvalidMessage = this.$t(
                        'feedbackAliasMinLengthErrorMessage'
                    );
                    this.invalidFormInput = true;
                    this.aliasError = true;
                    if (setMessage) {
                        this.feedbackErrorMessagesList.push({
                            message: this.aliasInvalidMessage
                        });
                    }
                    return true;
                }
                return false;
            },

            $_hasErrorInRequiredFields() {
                let hasError = false;
                // Check required fields (generic message)
                this.generalRequiredFields.forEach((field) => {
                    if (!this.feedback[field.fieldName]) {
                        const errorMessage = field.plural
                            ? `Er moeten nog ${field.textName} worden ingevuld.`
                            : `Er moet nog een ${field.textName} worden ingevuld.`;
                        this.feedbackErrorMessagesList.push({
                            message: errorMessage
                        });
                        hasError = true;
                    }
                });

                return hasError;
            },

            $_hasErrorInExpressionFields() {
                let hasError = false;
                // Check required fields (generic message)
                var expressionFields = this.feedback.feedbackFields.filter(
                    (f) => f.type === this.fieldTypeConst.EXPRESSION
                );
                for (var field of expressionFields) {
                    this.$_validateExpressionValue(field.expression, field);
                    if (field.invalidExpressionErrorMessage) {
                        hasError = true;
                        const errorMessage = this.$t('errorExpressionField', [
                            field.name
                        ]);
                        this.feedbackErrorMessagesList.push({
                            message: errorMessage
                        });
                    }
                }

                return hasError;
            },

            $_hasInvalidAdvancedStyle(style) {
                const isClusterTab =
                    this.feedback.useInWebTheme &&
                    this.advancedStyleTabIndex ===
                        ADVANCED_STYLE_TAB_INDEX.TAB_CLUSTER;
                style.hasAdvancedStyleError =
                    !isClusterTab &&
                    style.customStylingOptions !== null &&
                    style.customStylingOptions.attribute === null;
                return style.hasAdvancedStyleError;
            },

            $_hasErrorInStyles() {
                let hasError = false;
                // Check if feedback has at least one style
                if (
                    this.$_isUndefinedOrNull(this.feedback.styles) ||
                    !arrayNotEmpty(this.feedback.styles)
                ) {
                    this.feedbackErrorMessagesList.push({
                        message: this.$t('errorMissingStyle')
                    });
                    hasError = true;
                } else {
                    // Validate all the styles
                    this.feedback.styles.forEach((style) => {
                        this.$_scaleToResolution(style);
                        // Check required style fields
                        if (this.$_hasInvalidStrokeColor(style)) {
                            this.feedbackErrorMessagesList.push({
                                message:
                                    'Vul alle verplichte velden in bij de stijlen van de opslaglaag'
                            });
                            hasError = true;
                            this.feedback.styles.error = this.$t(
                                'errorRequiredFieldsUnset'
                            );
                        } else if (this.$_hasInvalidResolution(style)) {
                            // Check min & max resolution
                            this.feedbackErrorMessagesList.push({
                                message:
                                    'Vul het schaalbereik (min/max) in bij de stijlen van de opslaglaag'
                            });
                            hasError = true;
                            this.feedback.styles.error =
                                'Geen schaalbereik ingevuld.';
                        } else if (style.minResolution >= style.maxResolution) {
                            // Check if min resolution is smaller than max resolution
                            this.feedbackErrorMessagesList.push({
                                message:
                                    'Maak het minimum schaalbereik kleiner dan het maximum schaalbereik'
                            });
                            hasError = true;
                            this.feedback.styles.error =
                                'Minimum schaalbereik is niet kleiner dan maximum.';
                        } else if (
                            this.$_hasInvalidAdvancedStyle(style) ||
                            this.$_hasInvalidScale(style)
                        ) {
                            hasError = true;
                            this.feedbackErrorMessagesList.push({
                                message: `De volgende stijlen zijn onvolledig ingevuld: ${style.minScale} - ${style.maxScale}`
                            });
                        }
                    });
                }
                return hasError;
            },

            $_hasErrorInVisibleAndRequiredField(field) {
                let isValidRequiredFields = true;
                if (!this.$_fieldIsAllowedToBeInvisibleAndRequired(field)) {
                    // Show error for invalid required fields
                    isValidRequiredFields = false;
                    if (field.invisibleAndRequiredErrorMessage === null) {
                        this.feedbackErrorMessagesList.push({
                            message: this.$t(
                                'feedbackFieldInvisibleAndRequiredErrorMessage',
                                [` '${field.alias}'`]
                            )
                        });
                        field.invisibleAndRequiredErrorMessage = this.$t(
                            'feedbackFieldInvisibleAndRequiredErrorMessage',
                            ['']
                        );
                    } else if (
                        field.invisibleAndRequiredErrorMessage !== null &&
                        this.feedbackErrorMessage.length === 0
                    ) {
                        this.feedbackErrorMessagesList.push({
                            message: this.$t(
                                'feedbackFieldInvisibleAndRequiredErrorMessage',
                                [` '${field.alias}'`]
                            )
                        });
                    }
                } else {
                    field.invisibleAndRequiredErrorMessage = null;
                }
                return isValidRequiredFields;
            },

            /**
             * Check if feedback-fields have an error, that's the case if
             * - 1) required fields are invisible, without a default value
             * - 2) ??
             * - 3) the feedback field stype is still on the default 'Make selection' state
             * @return     {boolean}  { feedbackfields have an error if true }
             */
            $_hasErrorInFeedbackFields() {
                let hasValidFieldNames = true;
                let isValidRequiredFields = true;
                const isValidNotRequiredFields = true;
                let isValidTypeFields = true;
                let isValidDomainTypeFields = true;
                let invalidStateFields = false;
                let isValidCategory = true;

                // Validate fields
                if (this.feedback.feedbackFields) {
                    this.feedback.feedbackFields.forEach((field) => {
                        // check field name is not a reserved name
                        if (field.nameReserved) {
                            hasValidFieldNames = false;

                            this.feedbackErrorMessagesList.push({
                                message: this.$t('feedbackFieldNameErrorMessage', [
                                    field.alias
                                ])
                            });
                        }
                        // Check feedbackfields for required & invisible, with empty default values
                        isValidRequiredFields =
                            this.$_hasErrorInVisibleAndRequiredField(field);
                        isValidCategory = this.$_validateCategory(field);
                        // Check if new inputfield type is still in select mode
                        if (field.type === null) {
                            // Show error for empty type
                            isValidTypeFields = false;
                            const feedbackFieldFor = this.$t('feedbackFieldFor');
                            this.feedbackErrorMessagesList.push({
                                message: this.$t('feedbackFieldTypeErrorMessage', [
                                    ` ${feedbackFieldFor} '${field.alias}'`
                                ])
                            });
                            this.$_validateFieldTypeValues(field);
                        }
                        // Check if new inputfield domainType is still in select mode
                        isValidDomainTypeFields =
                            this.$_validateFieldDomainType(field);
                        if (
                            field.invalidFieldValue ||
                            field.invalidMinValueErrorMessage ||
                            field.invalidMaxValueErrorMessage ||
                            field.invalidMaxLengthErrorMessage ||
                            field.invalidExpressionErrorMessage
                        ) {
                            invalidStateFields = true;
                        }
                    });
                }
                // Return has error
                if (
                    !hasValidFieldNames ||
                    !isValidTypeFields ||
                    !isValidDomainTypeFields ||
                    !isValidNotRequiredFields ||
                    !isValidRequiredFields ||
                    invalidStateFields ||
                    !isValidCategory
                ) {
                    return true;
                }
                return false;
            },

            /**
             * Show the placeholder input when:
             * 1) Field type is ALPHANUMERIC or DATE
             * 2) Without a domain or with a domain and suggestion list
             * @param {any} fieldItem the fieldItem to check
             * @returns {boolean} true if placeholder field should be reset and hidden
             */
            $_showPlaceholderInput(fieldItem) {
                return (
                    (fieldItem.type === this.fieldTypeConst.ALPHANUMERIC ||
                        fieldItem.type === this.fieldTypeConst.DATE ||
                        fieldItem.type === this.fieldTypeConst.EMAIL) &&
                    (!fieldItem.domain ||
                        (fieldItem.domain &&
                            fieldItem.domainType ===
                                this.domainTypeConst.SUGGESTIONLIST))
                );
            },

            async $_initFeedbackAttributeData() {
                await this.$_getAvailableScales();
                await this.$_getAllDomains();

                // Retrieve possible field types
                this.getRefCodes(this.fieldTypeConst.KEY).then((result) => {
                    const refCodes = result.data;
                    const fieldTypes = refCodes.filter(
                        (rf) => rf.code !== this.fieldTypeConst.SELECT
                    );
                    // All fieldTypes, it won't be altered
                    this.allPossiblefields = Object.assign([], fieldTypes);
                    this.possiblefields = Object.assign([], fieldTypes);
                });

                // Retrieve possible domain types
                this.getRefCodes(this.domainTypeConst.KEY).then((result) => {
                    const refCodes = result.data;
                    this.domainTypes = refCodes.filter(
                        (rf) =>
                            rf.code !== this.domainTypeConst.ALL_VALUES &&
                            rf.code !== this.domainTypeConst.SELECT
                    );
                });

                // Retrieve possible value-input types
                this.getRefCodes(OPERATOR_TYPE.KEY).then((result) => {
                    this.possibleOperators = result.data;
                });

                // Retrieve possible where-clause types
                this.getRefCodes(WHERECLAUSE_TYPE.KEY).then((result) => {
                    this.possibleWhereClauseTypes = result.data;
                    this.$_setDefaultWhereClauseInput();
                });
            },

            $_isUndefinedOrNull(value) {
                return value === undefined || value === null;
            },

            $_isUndefinedNullOrEmpty(value) {
                return this.$_isUndefinedOrNull(value) || value === '';
            },

            $_maxLengthCheck(input, feedbackField) {
                if (
                    (feedbackField.type === this.fieldTypeConst.NUMERIC &&
                        (input <= 0 ||
                            input > this.maxLengthConstraints.NUMERIC)) ||
                    (feedbackField.type ===
                        this.fieldTypeConst.NUMERICWITHDECIMALS &&
                        (input <= 0 ||
                            input >
                                this.maxLengthConstraints.NUMERICWITHDECIMALS)) ||
                    (feedbackField.type === this.fieldTypeConst.ALPHANUMERIC &&
                        (input <= 0 ||
                            input > this.maxLengthConstraints.ALPHANUMERIC))
                ) {
                    return false;
                }
                return true;
            },

            /**
             * contentTypeId event handler
             */
            $_onChangeContentType(contentTypeId) {
                this.feedback.contentTypeId = contentTypeId;

                // Only add/remove extra fields in new mode
                if (this.editMode) {
                    return;
                }

                if (contentTypeId === this.contentTypeConst.MEASUREMENT) {
                    // No logging fo measurements
                    this.feedback.changeLogEnabled = false;
                    // sendStatusUpdates only when feedback. Set to false when measurement
                    this.feedback.sendStatusUpdates = false;

                    this.$_onChangeUseInWebTheme(false);

                    // Set personal default to true
                    this.feedback.personal = true;

                    // Web feedbacks can use Point geometry only
                    this.feedback.geometryTypeArray = ['P', 'L', 'V'];
                    this.$_setGeometryType(this.feedback.geometryTypeArray);

                    // Change default values for the checkboxes
                    this.$_changeCheckboxDefaultValues('aanmaker', false);
                    this.extraMeasureFields.forEach((field) => {
                        this.$_changeCheckboxDefaultValues(field.name, true);
                        this.$_setExportAndPrintDefaultValue(field.name, true);
                    });
                } else {
                    this.$_onChangeUseInWebTheme(this.feedback.useInWebTheme);

                    // Change default values for the checkboxes
                    this.extraMeasureFields.forEach((field) => {
                        this.$_changeCheckboxDefaultValues(field.name, false);
                        this.$_setExportAndPrintDefaultValue(field.name, false);
                    });
                }
            },

            /**
             * chkUseInWebTheme event handler
             * if checked => $scope.feedback.useInWebTheme === true
             * then only point geometrie is permitted
             */
            $_onChangeSendStatusUpdates(sendStatusUpdates) {
                // Switched to web-feedback
                if (sendStatusUpdates) {
                    // Add feedback-number
                    if (
                        this.feedback.contentTypeId ===
                        this.contentTypeConst.FEEDBACK
                    ) {
                        this.feedback.feedbackFields.push({
                            name: 'meldingsnummer',
                            alias: 'Meldingsnummer',
                            type: this.fieldTypeConst.GENERIC,
                            field_is_open: false,
                            tableView: true,
                            detailView: true,
                            popUp: true,
                            searchType: true
                        });
                    }
                } else {
                    // Switched to regular feedback
                    // Remove feedback-number && address & affiliate-number options for regularfeedback
                    this.feedback.feedbackFields =
                        this.feedback.feedbackFields.filter(
                            (ff) => ff.name !== 'meldingsnummer'
                        );
                }
            },

            $_containsFeedbackField(feedbackFieldName) {
                if (!feedbackFieldName || feedbackFieldName.length < 1) {
                    return false;
                }

                const feedbackFields = this.feedback.feedbackFields.filter(
                    (f) => f.name === feedbackFieldName
                );
                if (feedbackFields && feedbackFields.length > 0) {
                    return true;
                }
                return false;
            },

            /**
             * chkUseInWebTheme event handler
             * if checked => $scope.feedback.useInWebTheme === true
             * then only point geometrie is permitted
             */
            $_onChangeUseInWebTheme(useInWebTheme) {
                // Switched to web-feedback
                if (useInWebTheme) {
                    if (
                        this.feedback.contentTypeId ===
                        this.contentTypeConst.FEEDBACK
                    ) {
                        // Web feedback has at least point geometry
                        if (
                            !this.feedback.geometryTypeArray ||
                            this.feedback.geometryTypeArray?.length === 0
                        ) {
                            this.feedback.geometryTypeArray = ['P'];
                        }
                        this.$_setGeometryType(this.feedback.geometryTypeArray);
                    } else if (
                        this.feedback.contentTypeId ===
                        this.contentTypeConst.MEASUREMENT
                    ) {
                        // Set personal default to true
                        this.feedback.personal = true;
                    }

                    // Add feedback-number && address & affiliate-number options for webfeedback
                    if (!this.editMode) {
                        if (
                            this.feedback.contentTypeId ===
                            this.contentTypeConst.FEEDBACK
                        ) {
                            if (!this.$_containsFeedbackField('meldingsnummer')) {
                                this.feedback.feedbackFields.push({
                                    name: 'meldingsnummer',
                                    alias: 'Meldingsnummer',
                                    type: this.fieldTypeConst.GENERIC,
                                    field_is_open: false,
                                    tableView: true,
                                    detailView: true,
                                    popUp: true,
                                    searchType: true
                                });
                            }
                            if (!this.$_containsFeedbackField('aansluitnummer')) {
                                this.feedback.feedbackFields.push({
                                    name: 'aansluitnummer',
                                    alias: 'Aansluit-meldingsnummer',
                                    type: this.fieldTypeConst.GENERIC,
                                    field_is_open: false,
                                    tableView: true,
                                    detailView: true,
                                    popUp: true,
                                    searchType: false
                                });
                            }
                        }

                        this.$_changeCheckboxDefaultValues('aanmaker', false);
                    }
                } else {
                    // Switched to regular feedback
                    // Remove feedback-number && address & affiliate-number options for regularfeedback
                    if (!this.editMode) {
                        // $_onChangeUseInWebTheme is called from many different places. Not only when UseInWebTheme is changed.
                        // Prevent removal of "meldingsnummer" when sendStatusUpdates is true
                        if (!this.feedback.sendStatusUpdates) {
                            this.feedback.feedbackFields =
                                this.feedback.feedbackFields.filter(
                                    (ff) =>
                                        ff.name !== 'aansluitnummer' &&
                                        ff.name !== 'meldingsnummer'
                                );
                        } else {
                            this.feedback.feedbackFields =
                                this.feedback.feedbackFields.filter(
                                    (ff) => ff.name !== 'aansluitnummer'
                                );
                        }
                        this.$_changeCheckboxDefaultValues('aanmaker', true);
                    }

                    // Keep only the where-clauses with Filter type, only these are valid for regular feedbacks
                    this.feedback.whereClauses = this.feedback.whereClauses.filter(
                        (wc) => wc.type === this.whereClauseTypeConst.FILTER
                    );
                }

                // current adresfield if any
                const addressField = this.feedback.feedbackFields.find(
                    (field) => field.name === 'adres'
                );
                // remove adresfield
                this.feedback.feedbackFields = this.feedback.feedbackFields.filter(
                    (ff) => ff.name !== 'adres'
                );
                this.$_addAddressField(addressField);

                // Override default max scale for Webfeedback, equal to point drawing scale
                this.$_setDefaultMaxScaleAndResolution();
            },

            $_addAddressField(addressField) {
                const isFeedback =
                    this.feedback.contentTypeId === this.contentTypeConst.FEEDBACK;

                const isMeasureNoWeb =
                    this.feedback.contentTypeId ===
                        this.contentTypeConst.MEASUREMENT &&
                    !this.feedback.useInWebTheme;

                const hasAddressField = this.feedback.feedbackFields.find(
                    (field) => field.name === 'adres'
                );

                if (
                    !hasAddressField &&
                    this.$_hasPointGeometry &&
                    (isFeedback || isMeasureNoWeb) &&
                    this.id === -1 // Only add address field if we are creating a new feedback type.
                ) {
                    if (addressField) {
                        this.feedback.feedbackFields.push(addressField);
                    } else {
                        this.feedback.feedbackFields.push({
                            name: 'adres',
                            alias: 'Adres',
                            type: this.fieldTypeConst.GENERIC,
                            field_is_open: false,
                            tableView: true,
                            detailView: true,
                            popUp: true,
                            // #1944: Added fields
                            searchType: false,
                            exportable: false,
                            print: false,
                            personalData: false,
                            IsTextAttribute: false,
                            TextAttributeShowLabel: false,
                            TextAttributeLabel: null,
                            TextAttributeSeparator: null,
                            TextAttributeOrder: 0
                        });
                    }
                }
            },

            $_onChangeExportFeedback(value) {
                // Make all Exportable fields disabled.
            },

            /**
             * Sets the default values for maxScale and maxResolution
             */
            $_setDefaultMaxScaleAndResolution() {
                if (
                    this.feedback.useInWebTheme &&
                    this.feedback.contentTypeId === this.contentTypeConst.FEEDBACK
                ) {
                    this.feedback.styles[0].maxScale = 1500;
                    this.feedback.styles[0].maxResolution = 0.42;
                } else {
                    this.feedback.styles[0].maxScale = 12000;
                    this.feedback.styles[0].maxResolution = 3.36;
                }
            },

            $_onFieldShow(feedbackField) {
                this.currentFeedbackField = feedbackField;
            },

            /**
             * Sets the generated domain as selected
             * @param data
             */
            $_onModalGeneratedDomain(data) {
                this.domains.push({
                    errorMessage: '',
                    id: data.domain.id,
                    name: data.domain.name,
                    unavailable: false
                });
                this.$_domainSelected(data.domain.id, data.domain);
                this.savedFeedbackField.domainId = data.domain.id;
            },

            $_onModalDomainSaved(data) {
                this.$_getAllDomains();
                const message = this.getDomainModalMessage(data);
                if (message) {
                    this.showToast({
                        message: message,
                        variant: 'danger',
                        autoHideDelay: 5000,
                        noCloseButton: true
                    });
                }
                // Select new feedback in feedbackfield
                const feedbackField = this.feedback.feedbackFields.find(
                    (ff) => ff.id === this.currentFeedbackField.id
                );
                if (feedbackField) {
                    feedbackField.domainId = data.id;
                    feedbackField.domain = data;
                }
                this.savedFeedbackField = null;
            },

            $_openDomainModal(feedbackField) {
                this.savedFeedbackField = feedbackField;
                // The prop value of Modal needs to be changed in order to trigger
                // the Watch function in AddDomainModal component
                this.launchDomainModal = !this.launchDomainModal;
            },

            $_onUpdateAdvancedStyleTabIndex(tabIndex) {
                this.advancedStyleTabIndex = tabIndex;
            },

            $_onReevaluateStyle() {
                this.$_hasErrorInStyles();
            },

            $_ordedCategories(categories) {
                return orderBy(categories, 'name');
            },

            $_validateLayerName(result) {
                // Do not execute this code when the name is invalid.
                // Otherwise it ignores the invalid name and resets the status.

                if (this.nameError) {
                    return;
                }
                // Set the state of input to invalid and show the error melding
                if (result.data) {
                    this.nameInvalidMessage =
                        'Deze naam wordt al gebruikt als naam van een bestaande opslaglaag';
                    this.nameError = true;
                    // Reset the state to valid state
                } else {
                    this.nameInvalidMessage = '';
                    this.nameError = false;
                }
                if (
                    (this.layerAvailable && !this.feedback.alias) ||
                    this.feedback.alias === this.feedback.name_alias
                ) {
                    this.feedback.alias = this.feedback.name;
                    this.feedback.name_alias = this.feedback.name;
                    this.$_checkLayerAlias();
                } else {
                    this.feedback.name_alias = this.feedback.name;
                }
            },

            async $_checkLayerName() {
                // Set layerAvailable initially to true until the opposite is true
                this.layerAvailable = true;
                if (this.feedback.name) {
                    // Is the name a valid name?
                    this.nameError =
                        !validateStringForWordCharactersAndAtLeast3Chars(
                            this.feedback.name
                        );

                    if (this.nameError) {
                        this.nameInvalidMessage = this.$t(
                            'noSpacesAndAtLeast3Chars'
                        );
                        this.nameError = true;
                    }

                    if (this.nameError) {
                        return;
                    }
                    this.nameInvalidMessage = null;

                    if (!this.editMode) {
                        // Feedback naam naar lowercase converteren
                        // Feedback naam is only in Add mode editable
                        const feedbackName = this.feedback.name.toLowerCase();
                        const feedbackNameExistsParams = {
                            name: feedbackName,
                            feedbackId:
                                this.feedback.id !== undefined
                                    ? this.feedback.id
                                    : 0
                        };

                        const result = await this.$store.dispatch('useApiData', {
                            name: 'GetNameExists',
                            parameters: feedbackNameExistsParams
                        });

                        if (result) {
                            this.layerAvailable = !result.data;
                            // invalidFormInput is true if the layer not available
                            this.invalidFormInput = result.data;
                            this.$_validateLayerName(result);
                        }
                    }
                } else {
                    // Feedback name invalid, reset alias
                    this.feedback.alias = '';
                    this.name_alias = '';
                }
            },

            /**
             * Set the geometryType in order PLV
             * @return {string} [ordered geometrytype]
             */
            $_setGeometryTypeOrder(unOrderedGeometryType) {
                let geometryType = '';
                if (unOrderedGeometryType.indexOf('P') > -1) {
                    geometryType += 'P';
                }
                if (unOrderedGeometryType.indexOf('L') > -1) {
                    geometryType += 'L';
                }
                if (unOrderedGeometryType.indexOf('V') > -1) {
                    geometryType += 'V';
                }
                return geometryType;
            },

            async $_getSvgAddress(nameSvg) {
                if (!nameSvg || nameSvg.length === 0) {
                    return null;
                }

                try {
                    const result = await this.$store.dispatch('useApiData', {
                        name: 'PolygonSvgFile',
                        parameters: { Name: nameSvg }
                    });

                    return result.data.fileUrl;
                } catch (error) {
                    this.feedbackErrorMessagesList.push({
                        message: this.$t('errorSvgUrl')
                    });
                }
                return null;
            },

            async $_onSubmit() {
                this.feedbackErrorMessagesList = [];
                // Check the validity of the form
                if (this.$refs.feedbackform.checkValidity()) {
                    // check geometrytype, set order to 'PLV'
                    this.feedback.geometryType = this.$_setGeometryTypeOrder(
                        this.feedback.geometryType
                    );
                    // All fields must have proper value, go to Save and validate further
                    if (
                        this.$_validateFieldNonUniqueNames() &&
                        this.$_validateFieldNonUniqueAlias()
                    ) {
                        // add the http path to the SVG file
                        for (let style of this.feedback.styles) {
                            style.svgHttpAddress = await this.$_getSvgAddress(
                                style.nameSvg
                            );

                            // and the custom styling options
                            if (style.customStylingOptions?.rules) {
                                for (let rule of style.customStylingOptions.rules) {
                                    rule.svgHttpAddress =
                                        await this.$_getSvgAddress(rule.nameSvg);
                                }
                            }
                        }
                        this.$_save();

                        // set sendStatusUpdates value as database sendStatusUpdates value
                        this.originalSendStatusUpdates =
                            this.feedback.sendStatusUpdates;
                    } else {
                        this.feedbackErrorMessagesList.push({
                            message: 'Niet alle velden zijn correct ingevuld'
                        });
                        this.$_showErrors();
                    }
                } else {
                    // Some elements are not valid, so reset the error messages and start to validate
                    const hasErrorInFeedbackFields =
                        this.$_hasErrorInFeedbackFields();
                    const hasInalidateFeedbackFieldNames =
                        !this.$_validateFeedbackFieldNames();
                    const hasInvalidateFeedbackFieldAliases =
                        !this.$_validateFeedbackFieldAliases();
                    const hasErrors = this.$_feedbacklayerHasError();
                    // Validate first the feedback fields
                    if (
                        hasErrorInFeedbackFields ||
                        hasInalidateFeedbackFieldNames ||
                        hasInvalidateFeedbackFieldAliases ||
                        hasErrors
                    ) {
                        this.feedbackErrorMessagesList.push({
                            message: this.$t('errorRequiredFieldsUnset')
                        });
                        this.$_showErrors();
                    } else {
                        // No errors in feedback fields, start check the state of required fields
                        this.$refs.feedbackform.reportValidity();
                    }
                }
            },

            $_preselectDomainsForAllFields() {
                if (this.feedback.feedbackFields) {
                    this.feedback.feedbackFields.forEach((field) => {
                        field.domainId = null;
                        this.domains.forEach((domain) => {
                            if (field.domain && domain.id === field.domain.id) {
                                // Set the domainId for select list
                                // No additinal db calls for domain needed: initial domains are retrieved with the feedback-details object
                                field.domainId = field.domain.id;
                            }
                        });
                    });
                }
            },

            $_placeholderInputWhereValue(selectedField) {
                let placeholder = '';
                if (
                    selectedField &&
                    (selectedField.type === this.fieldTypeConst.DATE ||
                        selectedField.name === 'aanmaakdatum' ||
                        selectedField.name === 'wijzigingdatum')
                ) {
                    if (this.where.type === this.whereClauseTypeConst.REMOVE) {
                        placeholder = 'dd-mm-jjjj OF <SYSDATE>';
                    } else {
                        placeholder = 'dd-mm-jjjj';
                    }
                }
                return placeholder;
            },

            /**
             * remove invoer veld
             * @param {number}  styleIndex  The style index
             * @param {array}   array       The array
             * @param {any}     item        The item
             */
            $_removeField(styleIndex, array, item) {
                let index = styleIndex;

                // Update index if an item is given, delete the corresponding where-clauses
                if (item) {
                    index = array.findIndex((x) => x.name === item.name);

                    // Remove the where-clauses that correspond to the removed feedback-field
                    const remainingWheres = this.feedback.whereClauses.filter(
                        (wc) => wc.field.name !== item.name
                    );
                    this.feedback.whereClauses = remainingWheres;
                }
                return array.splice(index, 1);
            },

            $_removeItem(itemIndex, type, array, item) {
                const prefix =
                    type === this.itemTypes.style ||
                    type === this.itemTypes.whereClause
                        ? 'deze'
                        : 'dit';

                switch (type) {
                    case this.itemTypes.feedbackField:
                        this.$_deleteFeedbackField(itemIndex, array, item);
                        break;
                    case this.itemTypes.style:
                    case this.itemTypes.whereClause:
                    default: {
                        const defaultData = {
                            message: this.$t(
                                'feedbackCardTypeDeletionsConfirmation',
                                [`${prefix}`, `${type}`]
                            )
                        };
                        this.msgBoxConfirm(defaultData).then((confirm) => {
                            if (confirm) {
                                array = array.splice(itemIndex, 1);
                            }
                        });
                        break;
                    }
                }
            },

            $_resetFeedbackFieldErrors(feedbackField) {
                this.feedbackFieldError = '';
                feedbackField.invalidFieldError = '';
            },

            /**
             * Converts the min and max resolution to min and max scale
             * @param {object} styleItem - style
             */
            $_resolutionToScale(styleItem) {
                const max = this.availableScaleItems.filter((scaleItem) => {
                    return scaleItem.resolution === styleItem.maxResolution;
                });

                const min = this.availableScaleItems.filter((scaleItem) => {
                    return scaleItem.resolution === styleItem.minResolution;
                });

                const maxText = this.availableScaleItems.filter(
                    ({ resolution }) => {
                        return resolution === styleItem.textMaxResolution;
                    }
                );

                if (max.length > 0) {
                    styleItem.maxScale = max[0].scale;
                }

                if (min.length > 0) {
                    styleItem.minScale = min[0].scale;
                }

                // null value is allowed
                styleItem.textMaxScale =
                    maxText.length > 0 ? maxText[0].scale : null;

                if (!styleItem.minScale || !styleItem.maxScale) {
                    console.log('minScale or maxScale has no value!');
                }
            },

            $_setCategoriesAndFormatters() {
                // Remove all spaces from Name of fields
                // Set order
                // Set default dateformatter in case of date type (can be replaced later, as we only have 1 datettype)
                this.feedback.feedbackFields.forEach((field, index) => {
                    field.order = index;
                    field.name = field.name.replace(' ', '_');

                    // Set all dateFormats to 3, we only use this format from now on.
                    // If database model is cleaned, this shouldn't be necesary anymore
                    if (field.type === this.fieldTypeConst.DATE) {
                        field.dateFormatter = 3;
                    }
                    // set categories
                    if (field.type === this.fieldTypeConst.CATEGORY) {
                        // start from empty
                        field.feedbackFieldCategoryLookups = [];
                        for (const category of field.categories) {
                            if (category.selected) {
                                field.feedbackFieldCategoryLookups.push({
                                    id: category.categoryLookupId,
                                    feedbackFieldId: field.id,
                                    feedbackCategoryId: category.id
                                });
                            }
                        }
                    }
                });
            },

            /**
             * Save feedback theme.
             * @return {boolean} True if save succeeded, false otherwise
             */
            async $_save() {
                // if nog een invoerveld ingevuld?
                if (this.where?.selectedField) {
                    // voeg de whereClause toe
                    this.$_addItem(this.itemTypes.whereClause);
                }

                this.feedbackHasBeenSaved = true;

                if (this.$_hasAnyError()) {
                    this.$_showErrors();
                    return;
                }
                const added = this.feedback.id === undefined;
                this.isSaving = true;
                if (this.feedback.feedbackFields) {
                    this.$_setCategoriesAndFormatters();
                }
                this.feedback.personal =
                    this.feedback.contentTypeId === this.contentTypeConst.FEEDBACK
                        ? false
                        : this.feedback.personal;

                // Create new or modified storage layer object
                this.feedback.organization_id = this.userInfo.organizationId;
                nprogress.start();

                // Save to the database
                // Set 0 timeout for testing..
                try {
                    // GGR initialize id's to 0 for new items
                    this.feedback.styles.forEach((style) => {
                        if (typeof style.id === 'string') {
                            style.id = 0;
                        }
                    });
                    this.feedback.feedbackFields.forEach((feedbackField) => {
                        if (typeof feedbackField.id === 'string') {
                            feedbackField.id = 0;
                        }
                    });
                    if (!added) {
                        const advLabelTab = this.$refs.advancedLabelTab;
                        if (advLabelTab != null) {
                            advLabelTab.$_onClickChangeOrder();
                        }
                    }

                    if (
                        !this.$_showTextAttribute &&
                        this.feedback.styles.length > 0
                    ) {
                        // advanced label, then we delete "simple label"
                        this.feedback.styles[0].textAttributeDefault = '';
                    }

                    const data = cleanData(this.feedback);
                    const result = await this.$store.dispatch('useApiData', {
                        name: added ? 'CreateFeedbackType' : 'UpdateFeedbackType',
                        data: data
                    });
                    this.$_handleResult(result, added);
                } catch (error) {
                    nprogress.done();
                    this.isSaving = false;
                    const data = {
                        message: `Foutmelding: ${
                            this.$t(error?.message) ||
                            error?.response?.message ||
                            error?.data?.response?.data?.message
                        }`,
                        variant: 'danger',
                        title: this.$t('saveFailureTitle'),
                        autoHideDelay: 5000
                    };
                    this.showToast(data);
                }
            },

            async $_handleResult(result, added) {
                if (result) {
                    this.isSaving = false;
                    if (
                        result.data.id &&
                        result.data.nonSynchronizedFields.length === 0
                    ) {
                        // do harvest of the (modified) information attributes
                        const themeId = result.data.themeId;
                        await this.$store.dispatch('useApiData', {
                            name: 'HarvestTheme',
                            data: {
                                themeId
                            }
                        });

                        const data = {
                            message: this.$t('feedbackCardSavedConfirmation'),
                            variant: 'success',
                            autoHideDelay: 2500,
                            noCloseButton: true
                        };
                        this.originalFeedbackFields = this.feedback.feedbackFields;
                        this.showToast(data);
                        if (added) {
                            this.$_gotoOverview();
                        }
                        // Save succeeded, but feedback is not synchronized correctly
                    } else if (result.data.id) {
                        const data = {
                            message: `${this.$t(
                                'errorSaveFeedBackPart1'
                            )} ${result.data.nonSynchronizedFields.join(
                                ', '
                            )}. ${this.$t('errorSaveFeedBackPart2')}`,
                            variant: 'danger',
                            title: this.$t('saveFailureTitle'),
                            autoHideDelay: 10000
                        };
                        this.showToast(data);
                    }
                    nprogress.done();
                }
            },

            /**
             * Converts the min and max scale to min and max resolution
             * @param {object} styleItem - style
             */
            $_scaleToResolution(styleItem) {
                const max = this.availableScaleItems.filter((scaleItem) => {
                    return scaleItem.scale === styleItem.maxScale;
                });

                const min = this.availableScaleItems.filter((scaleItem) => {
                    return scaleItem.scale === styleItem.minScale;
                });

                const maxText = this.availableScaleItems.filter(({ scale }) => {
                    return scale === styleItem.textMaxScale;
                });

                if (max.length > 0) {
                    styleItem.maxResolution = max[0].resolution;
                }

                if (min.length > 0) {
                    styleItem.minResolution = min[0].resolution;
                }

                // null value is allowed
                styleItem.textMaxResolution =
                    maxText.length > 0 ? maxText[0].resolution : null;

                if (!styleItem.minResolution || !styleItem.maxResolution) {
                    console.log('minResolution or maxResolution has no value!');
                }
            },

            $_selectFeedbackFieldCategories(feedbackField) {
                // select the categories from feedbackField.feedbackFieldCategoryLookups
                for (const feedbackFieldCategoryLookup of feedbackField.feedbackFieldCategoryLookups) {
                    const found = feedbackField.categories.find((e) => {
                        return (
                            e.id === feedbackFieldCategoryLookup.feedbackCategoryId
                        );
                    });
                    if (found) {
                        found.categoryLookupId = feedbackFieldCategoryLookup.id;
                        found.selected = true;
                    }
                }
            },

            $_setDefaultFieldTypeValues(event, feedbackField) {
                feedbackField.type = event;
                this.$_validateFieldTypeValues(feedbackField);
                this.$_updatePossiblefields();
                feedbackField.invalidExpressionErrorMessage = null;
                switch (feedbackField.type) {
                    case this.fieldTypeConst.ALPHANUMERIC:
                        feedbackField.nrRows = 1;
                        feedbackField.maxLength =
                            this.defaultValueAlphanumericField;
                        feedbackField.defaultValue = null;
                        break;
                    case this.fieldTypeConst.NUMERIC:
                    case this.fieldTypeConst.NUMERICWITHDECIMALS:
                        feedbackField.maxLength = 9;
                        feedbackField.domain = null;
                        feedbackField.domainId = null;
                        feedbackField.domainType = null;
                        feedbackField.defaultValue = null;
                        break;
                    case this.fieldTypeConst.EMAIL:
                        feedbackField.personalData = true;
                        feedbackField.maxLength = 100;
                        feedbackField.nrRows = 1;
                        feedbackField.domain = null;
                        feedbackField.domainId = null;
                        feedbackField.domainType = null;
                        feedbackField.defaultValue = null;
                        break;
                    case this.fieldTypeConst.STATE:
                        feedbackField.visible = false;
                        feedbackField.required = true;
                        feedbackField.domainType = null;
                        feedbackField.nrRows = 1;
                        feedbackField.domain = null;
                        feedbackField.domainId = null;
                        feedbackField.domainType = null;
                        feedbackField.defaultValue = null;
                        break;
                    case this.fieldTypeConst.DATE:
                        // Currently no defaults
                        feedbackField.domain = null;
                        feedbackField.domainId = null;
                        feedbackField.domainType = null;
                        feedbackField.defaultValue = null;
                        break;
                    case this.fieldTypeConst.FOTO:
                        // Currently no defaults
                        feedbackField.domain = null;
                        feedbackField.domainId = null;
                        feedbackField.domainType = null;
                        feedbackField.defaultValue = null;
                        break;
                    case this.fieldTypeConst.GENERIC:
                        // Currently no defaults
                        break;
                    case this.fieldTypeConst.EXPRESSION:
                        feedbackField.visible = true;
                        feedbackField.required = false;
                        feedbackField.domain = null;
                        feedbackField.domainId = null;
                        feedbackField.domainType = null;
                        feedbackField.defaultValue = null;
                        break;
                }
                feedbackField.value = '';
                this.$_feedbacklayerHasError();
            },

            /**
             *  Sets the default values for where-clause input
             */
            $_setDefaultWhereClauseInput() {
                // Clear input and set default values
                this.where = {
                    selectedField: null,
                    selectedoperator: null,
                    value: '',
                    type: null
                };
            },

            $_setGeometryType(input) {
                const geomTypeArray = input;
                // Join the geometry-types to string for storage in database
                // P for point, L for line, V for vlak (= polygon)
                this.feedback.geometryType = geomTypeArray
                    ? geomTypeArray.join('')
                    : '';
                if (!this.feedback.useInWebTheme) {
                    this.$_onChangeUseInWebTheme(false);
                }
                this.$_feedbacklayerHasError();
            },

            $_showDefaultValue(feedbackField) {
                return (
                    feedbackField.type === this.fieldTypeConst.ALPHANUMERIC ||
                    feedbackField.type === this.fieldTypeConst.DATE ||
                    feedbackField.type === this.fieldTypeConst.CATEGORY ||
                    feedbackField.type === this.fieldTypeConst.NUMERIC ||
                    feedbackField.type ===
                        this.fieldTypeConst.NUMERICWITHDECIMALS ||
                    feedbackField.type === this.fieldTypeConst.STATE ||
                    feedbackField.type === this.fieldTypeConst.EXPRESSION
                );
            },

            /*
             * Flushes the array of errors
             */
            $_showErrors() {
                for (
                    var index = 0;
                    index < this.feedbackErrorMessagesList.length &&
                    index < this.maxNumberOfFeedbackErrors;
                    index++
                ) {
                    const data = {
                        message: this.feedbackErrorMessagesList[index].message,
                        variant: 'danger',
                        noCloseButton: true,
                        autoHideDelay: 8000
                    };
                    this.showToast(data);
                }
            },

            $_typeOptions(feedbackField) {
                const option = [];

                if (this.possiblefields.length > 0) {
                    const filteredOptions = this.$_filterTypeOptions(
                        feedbackField.newi
                    );
                    for (let filteredOption of filteredOptions) {
                        option.push({
                            value: filteredOption.code,
                            text: filteredOption.description,
                            disabled:
                                filteredOption.disabled !== undefined
                                    ? filteredOption.disabled
                                    : false
                        });
                    }
                }
                return option.sort((a, b) => a.text.localeCompare(b.text));
            },

            /**
             * Resets the defaultValue if the defaultValue is not selected anymore
             * @param feedbackField
             */
            $_updateFieldDefaultValue(feedbackField) {
                if (feedbackField.defaultValue && this.categoryOptions.length > 0) {
                    const foundOption = this.categoryOptions.find(
                        (option) =>
                            option.text.toLowerCase() ===
                            feedbackField.defaultValue.toLowerCase()
                    );
                    if (!foundOption) {
                        feedbackField.defaultValue = null;
                    }
                }
            },

            /**
             * Filteres out the options "Categorie", "Status" and "EMAIL" if the feedback has already a feedback field with such field types
             */
            $_updatePossiblefields() {
                // Restore field types in case of removing existing fields
                this.possiblefields = this.allPossiblefields.map((element) => {
                    return {
                        code: element.code,
                        description: element.description
                    };
                });
                // Check whether feedback has already a field type category
                const feedbackWithCatagory = this.feedback.feedbackFields.find(
                    (field) => field.type === this.fieldTypeConst.CATEGORY
                );
                if (feedbackWithCatagory) {
                    // Filter out the option CATEGORY
                    const index = this.possiblefields.findIndex(
                        (field) => field.code === this.fieldTypeConst.CATEGORY
                    );
                    this.possiblefields[index].disabled = true;
                }
                // Check whether feedback has already a field type state
                const feedbackWithStatus = this.feedback.feedbackFields.find(
                    (field) => field.type === this.fieldTypeConst.STATE
                );
                if (feedbackWithStatus) {
                    // Filter out the option STATE
                    const index = this.possiblefields.findIndex(
                        (field) => field.code === this.fieldTypeConst.STATE
                    );
                    this.possiblefields[index].disabled = true;
                }

                // Check whether feedback has already a field type email
                const feedbackWithEmail = this.feedback.feedbackFields.find(
                    (field) => field.type === this.fieldTypeConst.EMAIL
                );
                if (feedbackWithEmail) {
                    // Filter out the option STATE
                    const index = this.possiblefields.findIndex(
                        (field) => field.code === this.fieldTypeConst.EMAIL
                    );
                    this.possiblefields[index].disabled = true;
                }
            },

            /**
             * Disable/Enable chkUseInWebTheme checkbox
             */
            $_useInWebThemeEnabled() {
                // returning true means disable the field
                return this.editMode
                    ? this.editMode
                    : !this.$store.getters.userInfo.licenses.has_mobile_license;
            },

            /**
             * Validates field type Category for at least one category field selected
             * @param field
             */
            $_validateCategory(field) {
                if (
                    field.type === this.fieldTypeConst.CATEGORY &&
                    field.categories
                ) {
                    const selectedCategory = field.categories.find(
                        (category) => category.selected === true
                    );
                    if (selectedCategory === undefined) {
                        if (
                            this.catetoryState === false &&
                            this.feedbackErrorMessage.length === 0
                        ) {
                            this.feedbackErrorMessagesList.push({
                                message: this.$t(
                                    'feedbackFieldCategoryErrorMessage',
                                    [` '${field.alias}'`]
                                )
                            });
                        }
                        this.catetoryState = false;
                        this.invalidCategoryMessage = this.$t(
                            'errorNoCategorySelected'
                        );
                    } else {
                        this.catetoryState = null;
                        this.invalidCategoryMessage = '';
                    }
                }
                return this.catetoryState === null;
            },

            $_validateMaxLength(input, feedbackField) {
                let maxValue;
                // The constants are called maxlength but it's actually the max value
                // for the max length parameter.
                if (feedbackField.type === this.fieldTypeConst.NUMERIC) {
                    maxValue = this.maxLengthConstraints.NUMERIC;
                } else if (
                    feedbackField.type === this.fieldTypeConst.NUMERICWITHDECIMALS
                ) {
                    maxValue = this.maxLengthConstraints.NUMERICWITHDECIMALS;
                } else if (
                    feedbackField.type === this.fieldTypeConst.ALPHANUMERIC
                ) {
                    maxValue = this.maxLengthConstraints.ALPHANUMERIC;
                }

                if (input <= 0 || input > maxValue) {
                    this.invalidMessageMaxLength = `Kies een getal tussen 1 en ${maxValue}`;
                    this.feedbackFieldError = this.$t('errorMaxLength');
                } else {
                    this.invalidMessageMaxLength = '';

                    // if max length is ok check if minValue, maxValue and default are still ok.
                    this.$_validateMinValue(feedbackField.minValue, feedbackField);
                    this.$_validateMaxValue(feedbackField.maxValue, feedbackField);
                    this.$_validateDefaultValue(
                        feedbackField.defaultValue,
                        feedbackField
                    );
                }
            },

            $_validateMinValue(input, feedbackField) {
                if (input && input.length > 0) {
                    // check max lengte
                    const maxLengthField = feedbackField.maxLength
                        ? feedbackField.maxLength
                        : this.defaultValueAlphanumericField;
                    if (input.length > maxLengthField) {
                        feedbackField.invalidMinValueErrorMessage = `De maximale lengte ${maxLengthField} is overschreden`;
                        return;
                    }

                    if (
                        feedbackField.maxValue &&
                        feedbackField.maxValue.length > 0 &&
                        Number(input) >= Number(feedbackField.maxValue)
                    ) {
                        feedbackField.invalidMinValueErrorMessage =
                            'De minimum waarde moet kleiner zijn dan de maximum waarde';
                        return;
                    }
                }
                this.$_validateDefaultValue(
                    feedbackField.defaultValue,
                    feedbackField
                );
                feedbackField.invalidMinValueErrorMessage = '';

                // If minValue is ok check if default value is still ok.
                this.$_validateDefaultValue(
                    feedbackField.defaultValue,
                    feedbackField
                );
            },

            $_validateMaxValue(input, feedbackField) {
                if (input && input.length > 0) {
                    // check max lengte
                    const maxLengthField = feedbackField.maxLength
                        ? feedbackField.maxLength
                        : this.defaultValueAlphanumericField;
                    if (input.length > maxLengthField) {
                        feedbackField.invalidMaxValueErrorMessage = `De maximale lengte ${maxLengthField} is overschreden`;
                        return;
                    }

                    if (
                        feedbackField.minValue &&
                        feedbackField.minValue.length > 0 &&
                        parseInt(input) <= parseInt(feedbackField.minValue)
                    ) {
                        feedbackField.invalidMaxValueErrorMessage =
                            'De maximum waarde moet groter zijn dan de minimum waarde';
                        return;
                    }
                }
                this.$_validateDefaultValue(
                    feedbackField.defaultValue,
                    feedbackField
                );
                feedbackField.invalidMaxValueErrorMessage = '';

                // If maxValue is ok check if default value is still ok.
                this.$_validateDefaultValue(
                    feedbackField.defaultValue,
                    feedbackField
                );
            },

            // Check an expression
            // - All fields must exist
            // - Type must be numeric or numeric with decimals
            // - Numeric fields must be required fields
            // return array with errors
            //
            $_checkFields(fieldNames) {
                let errors = [];
                for (const fieldName of fieldNames) {
                    //

                    // aparte afhandeling lengte, length, oppervlakte, area
                    if (
                        ['lengte', 'length', 'oppervlakte', 'area'].indexOf(
                            fieldName
                        ) > -1
                    ) {
                        const error = this.$_checkLengthAndArea(
                            fieldName.toLowerCase()
                        );
                        if (error) {
                            errors.push(error);
                        }
                    } else {
                        var field = this.feedback.feedbackFields.find((f) => {
                            return f.name === fieldName.toLowerCase();
                        });

                        // field must exist and be numeric, numeric with decimals of alphanumeric
                        if (
                            field &&
                            (field.type ===
                                this.fieldTypeConst.NUMERICWITHDECIMALS ||
                                field.type === this.fieldTypeConst.NUMERIC)
                        ) {
                            // if numeric of alphanumeric field must be a required field

                            if (!field.required) {
                                errors.push(
                                    this.$t('errorExpressionFieldNotRequired', [
                                        fieldName
                                    ])
                                );
                            }
                        } else {
                            errors.push(
                                this.$t('errorExpressionFieldNotExist', [fieldName])
                            );
                        }
                    }
                }

                return errors;
            },

            $_checkLengthAndArea(fieldName) {
                if (fieldName === 'lengte') {
                    return this.$t('errorExpressionLengte');
                }
                if (fieldName === 'oppervlakte') {
                    return this.$t('errorExpressionOppervlakte');
                }

                if (!this.feedback.geometryType) {
                    return this.$t('errorExpresssionLengthArea');
                }

                if (
                    fieldName === 'length' &&
                    ['L', 'V', 'LV'].indexOf(this.feedback.geometryType) == -1
                ) {
                    return this.$t('errorExpressionLength');
                }

                if (fieldName === 'area' && this.feedback.geometryType != 'V') {
                    return this.$t('errorExpressionArea');
                }

                return null;
            },

            $_validateExpressionValue(input, feedbackField) {
                // Expression must a least contain 1 field.
                // This field must be numeric or numeric with decimals

                // No expression
                if (!input) {
                    // The expression must contain at least 1 variable;
                    feedbackField.invalidExpressionErrorMessage = this.$t(
                        'errorExpressionNoVariables'
                    );
                    return;
                }

                feedbackField.expression = input.toLowerCase();

                // Get all [variables] from the string
                var fieldNames = getVariablesFromString(feedbackField.expression);

                if (fieldNames.length === 0) {
                    // The expression must contain at least 1 variable;
                    feedbackField.invalidExpressionErrorMessage = this.$t(
                        'errorExpressionNoVariables'
                    );
                    this.$forceUpdate();
                    return;
                }

                var errors = this.$_checkFields(fieldNames);

                if (errors.length > 0) {
                    feedbackField.invalidExpressionErrorMessage = errors.join(' ');
                    this.$forceUpdate();
                    return;
                }

                let valueObject = {};

                try {
                    for (const fieldName of fieldNames) {
                        valueObject[fieldName] = 1;
                    }
                    evaluateNumericExpression(input, valueObject);
                } catch (error) {
                    feedbackField.invalidExpressionErrorMessage =
                        this.$t('errorExpression');
                    this.$forceUpdate();
                    return;
                }

                feedbackField.invalidExpressionErrorMessage = '';
                this.$forceUpdate();
            },

            $_validateDefaultValue(input, feedbackField) {
                this.$_resetFeedbackFieldErrors(feedbackField);
                // Test when there is input
                if (input && input.length > 0) {
                    // is numeric numeric?
                    if (feedbackField.type === this.fieldTypeConst.NUMERIC) {
                        if (!this.intRegex.test(input)) {
                            feedbackField.invalidFieldError =
                                'Vul numeriek waarde in';
                            this.feedbackFieldError = this.$t('errorDefaultValue');
                            return;
                        }
                    }

                    if (
                        feedbackField.type ===
                            this.fieldTypeConst.NUMERICWITHDECIMALS &&
                        isNaN(parseFloat(input))
                    ) {
                        feedbackField.invalidFieldError = 'Vul numeriek waarde in';
                        this.feedbackFieldError = this.$t('errorDefaultValue');
                        return;
                    }

                    // If numeric check min and max value
                    if (
                        feedbackField.type ===
                            this.fieldTypeConst.NUMERICWITHDECIMALS ||
                        this.fieldTypeConst.NUMERIC
                    ) {
                        if (
                            feedbackField.minValue &&
                            parseFloat(input) < parseInt(feedbackField.minValue)
                        ) {
                            feedbackField.invalidFieldError =
                                'Waarde moet gelijk zijn aan of groter zijn dan de minimum waarde';
                            this.feedbackFieldError = this.$t('errorDefaultValue');
                            return;
                        }
                        if (
                            feedbackField.maxValue &&
                            parseFloat(input) > parseInt(feedbackField.maxValue)
                        ) {
                            feedbackField.invalidFieldError =
                                'Waarde moet kleiner zijn dan of gelijk zijn aan de maximum waarde';
                            this.feedbackFieldError = this.$t('errorDefaultValue');
                            return;
                        }
                    }

                    const maxLengthField = feedbackField.maxLength
                        ? feedbackField.maxLength
                        : this.defaultValueAlphanumericField;
                    if (input.length > maxLengthField) {
                        feedbackField.invalidFieldError = `De maximale lengte ${maxLengthField} is overschreden`;
                        this.feedbackFieldError = this.$t('errorDefaultValue');
                    }
                }
            },

            $_validateMaxLengthNrOfRows(input) {
                if (input <= 0 || input > this.maxLengthConstraints.NUMBEROFROWS) {
                    this.invalidMessageMaxLengthNrOfRows = `Kies een getal tussen 1 en ${this.maxLengthConstraints.NUMBEROFROWS}`;
                    this.feedbackFieldError = this.$t('errorNrRows');
                } else {
                    this.invalidMessageMaxLengthNrOfRows = '';
                    this.feedbackFieldError = '';
                }
            },

            $_validateFieldNonUniqueNames() {
                let alFieldNamesAreUnique = true;
                for (let feedbackField of this.feedback.feedbackFields) {
                    if (
                        stringNotEmpty(feedbackField.invalidFieldNameErrorMessage)
                    ) {
                        alFieldNamesAreUnique = false;
                        break;
                    }
                }
                return alFieldNamesAreUnique;
            },

            $_validateFieldNonUniqueAlias() {
                let alFieldAliasesAreUnique = true;
                for (let feedbackField of this.feedback.feedbackFields) {
                    if (
                        stringNotEmpty(feedbackField.invalidFieldAliasErrorMessage)
                    ) {
                        alFieldAliasesAreUnique = false;
                        break;
                    }
                }
                return alFieldAliasesAreUnique;
            },

            $_validateFeedbackFieldNames() {
                let isValid = true;
                this.feedback.feedbackFields.forEach((field) => {
                    if (
                        stringNotEmpty(field.invalidFieldNameErrorMessage) &&
                        isValid
                    ) {
                        isValid = false;
                    } else {
                        this.$_validateFieldName(field);
                        isValid =
                            !stringNotEmpty(field.invalidFieldNameErrorMessage) &&
                            isValid;
                    }
                });
                return isValid;
            },

            $_validateFieldName(field) {
                if (field.newi) {
                    field.invalidFieldNameErrorMessage = stringNotEmpty(field.name)
                        ? ''
                        : this.$t('requiredField');
                } else {
                    // Don't validate name for existing fields
                    field.invalidFieldNameErrorMessage = '';
                }
            },

            $_validateFeedbackFieldAliases() {
                let isValid = true;
                this.feedback.feedbackFields.forEach((field) => {
                    this.$_validateFieldAlias(field);
                    if (
                        stringNotEmpty(field.invalidFieldAliasErrorMessage) &&
                        isValid
                    ) {
                        isValid = false;
                    }
                });
                return isValid;
            },

            $_validateFieldAlias(field) {
                field.invalidFieldAliasErrorMessage = stringNotEmpty(field.alias)
                    ? ''
                    : this.$t('requiredField');
                if (!stringNotEmpty(field.invalidFieldAliasErrorMessage)) {
                    const existingFields = this.feedback.feedbackFields.concat(
                        this.originalFeedbackFields
                    );
                    for (let existingField of existingFields) {
                        if (
                            existingField.id !== field.id &&
                            existingField.alias.toLowerCase() ===
                                field.alias.toLowerCase()
                        ) {
                            field.invalidFieldAliasErrorMessage =
                                'Deze alias bestaat al';
                            break;
                        }
                    }
                }
            },

            $_validateFieldDomainType(field) {
                let isValid = true;
                if (
                    field.domain &&
                    field.type !== this.fieldTypeConst.STATE &&
                    !field.domainType
                ) {
                    isValid = false;
                    // Show error for empty domainType
                    if (stringNotEmpty(field.domainTypeErrorMessage)) {
                        const feedbackFieldFor = this.$t('feedbackFieldFor');
                        this.feedbackErrorMessagesList.push({
                            message: this.$t(
                                'feedbackFieldDomainTypeErrorMessage',
                                [` ${feedbackFieldFor} '${field.alias}'`]
                            )
                        });
                    }
                    this.$_validDomainType(field);
                }
                return isValid;
            },

            $_validDomainType(field) {
                field.domainTypeErrorMessage =
                    field.domain !== null && field.domainType === null
                        ? this.$t('requiredField')
                        : '';
            },

            $_validateFieldTypeValues(feedbackField) {
                feedbackField.typeErrorMessage =
                    feedbackField.type === null ? this.$t('requiredField') : '';
            },

            $_validateWhereInput() {
                const typeValid = this.feedback.useInWebTheme
                    ? this.where.type === null
                    : false;
                if (
                    this.where.selectedField === null ||
                    this.where.selectedoperator === null ||
                    this.where.value.length === 0 ||
                    typeValid
                ) {
                    return false;
                }
                return true;
            },

            $_validateWhere(selectedField, value) {
                setTimeout(() => {
                    this.$_validateWhereValue(selectedField, value);
                }, 500);
            },

            $_handleGenericFieldType(selectedField, value, allowSysdate) {
                if (
                    selectedField.name === 'aanmaakdatum' ||
                    selectedField.name === 'wijzigingdatum' ||
                    selectedField.name === 'verwijderdatum'
                ) {
                    // RLI: deze behandelen als een datumveld
                    if (validateDate(value, allowSysdate)) {
                        return true;
                    }
                    this.feedbackFieldError = this.$t('labelInvalidDate');
                } else {
                    // alle invoer is toegestaan
                    return true;
                }
                // eslint warning
                return null;
            },

            /**
             * Valideer de where clause
             * @param  {object} event        AngularJS event object
             * @param  {object} selectedField het type te gebruiken voor validatie
             * @param  {string} value         de te valideren waarde
             * @return {bool}                 true indien geen validatie fouten, ander false
             */
            $_validateWhereValue(selectedField, value) {
                this.feedbackFieldError = '';
                // geen validatie op domein waarden
                if (this.$_shouldValidateWhereValue(selectedField, value)) {
                    // Only allow sysdate input for Remove where-clauses
                    const allowSysdate =
                        this.where.type === this.whereClauseTypeConst.REMOVE;
                    switch (selectedField.type) {
                        case this.fieldTypeConst.GENERIC:
                            this.$_handleGenericFieldType(
                                selectedField,
                                value,
                                allowSysdate
                            );
                            break;
                        case this.fieldTypeConst.NUMERIC:
                            if (validateNumber(value)) {
                                return true;
                            }
                            this.feedbackFieldError =
                                'Geen geldige numerieke waarde opgegeven.';
                            break;
                        case this.fieldTypeConst.NUMERICWITHDECIMALS:
                            if (validateNumber(value)) {
                                return true;
                            }
                            this.feedbackFieldError =
                                'Geen geldige numerieke waarde opgegeven.';
                            break;
                        case this.fieldTypeConst.ALPHANUMERIC:
                            // alle invoer is toegestaan
                            return true;
                        case this.fieldTypeConst.DATE:
                            if (validateDate(value, allowSysdate)) {
                                return true;
                            }
                            this.feedbackFieldError = this.$t('labelInvalidDate');
                            break;
                    }
                }
                return false;
            },

            $_whereClauseOptions(feedbackFields) {
                const orderedFields = orderBy(feedbackFields, 'alias');
                return convertToValueTextPair(orderedFields, 'name', 'alias');
            },

            /**
             * Check if the where clause should be validated
             * Validate when
             *   - a field is selected, and
             *   - the where-clause has a non-empty value, or
             *   - in case of numeric values, also validate empty values
             * @param  {object} where         the input where-clause object
             * @return {bool}                 true if where object should be validated
             */
            $_shouldValidateWhereValue(selectedField, value) {
                return (
                    selectedField &&
                    selectedField.type &&
                    (value ||
                        selectedField.type === this.fieldTypeConst.NUMERIC ||
                        selectedField.type ===
                            this.fieldTypeConst.NUMERICWITHDECIMALS)
                );
            },

            $_domainTypeValueOptions(domainKeyValues) {
                return convertToValueTextPair(domainKeyValues, 'key', 'value').sort(
                    arraySortAscendingFunction('text')
                );
            },

            $_onCopyFeedback() {
                this.$router.push({
                    path: `/dashboard/feedback/detail/copy/${this.id}`
                });
            }
        }
    };
</script>

<style scoped>
.font-weight-normal {
    font-weight: normal;
}

/*makes the color of lable of an input disabled*/
input:disabled + label {
    color: #ccc;
}

.fa-arrows-alt:hover {
    cursor: move;
}

.row-divider {
    height: 10px;
}

.keep-inline {
    display: -ms-flexbox;
    display: flex;
    align-items: center;
}

.btn-float {
    margin-top: 8px;
    margin-right: 14px;
}

.where-value {
    word-break: break-all;
}

.header-button {
    width: 60px;
    text-align: center;
}

.invalid-state {
    border: thin solid red;
}

.no-margin-bottom {
    margin-bottom: 0rem !important;
}
</style>
